var pageLoad = 1;
var pageNumber = 1;
var isNextPage = false;
var canadaRate = 1;
var giftGuidePage = false;
var pageCursor = '';
var applyingFilter = false;
var loadingMore = false;
var preparedSwatchData = {};
var currentFilters = [];
var loadinSpecialCollection = false;
var MAX_PRODUCTS_PER_COLLECTION = 120;
var renderRequestId = 0;
const isChromeBrowser = !!window.chrome && navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Edg') && !navigator.userAgent.includes('OPR');

//AB test for product limit
const paramsLimit = new URLSearchParams(window.location.search);
let limitCount = parseInt(paramsLimit.get('limit'), 10);
if (!isNaN(limitCount) && limitCount > 0 && limitCount <= MAX_PRODUCTS_PER_COLLECTION) {
    MAX_PRODUCTS_PER_COLLECTION = limitCount;
}

const isBackNavigation = (event) => {
    const navEntry = performance.getEntriesByType?.("navigation")?.[0];
    return (event && event.persisted) || (navEntry && navEntry.type === "back_forward");
};

(() => {
    const navEntry = performance.getEntriesByType?.("navigation")?.[0];
    const isBackForward = navEntry && navEntry.type === "back_forward";
    if (isChromeBrowser && isBackForward && "scrollRestoration" in history) {
        history.scrollRestoration = "manual";
        const rootEl = document.documentElement;
        const prevScrollBehavior = rootEl.style.scrollBehavior;
        rootEl.style.scrollBehavior = "auto";
        window.scrollTo({ top: 760, left: 0, behavior: "auto" });
        rootEl.style.scrollBehavior = prevScrollBehavior;
    }
})();

window.addEventListener("pageshow", function (event) {
    loadingMore = false;
    if (isChromeBrowser && isBackNavigation(event) && "scrollRestoration" in history) {
        // history.scrollRestoration = "manual";
        // window.scrollTo({ top: 1, left: 0, behavior: "auto" })
        // requestAnimationFrame(() => {
        //     window.scrollTo({ top: 1000, left: 0, behavior: "auto" });
        // });
    } else {
        removeSkeleton();
    }
});


(async function () {

    // Utils
    const Utils = {};

    const getBuyerContextVariables = () => {
        try {
            const accessToken = localStorage.getItem("customerAccessToken");
            const storedLocationId = localStorage.getItem("companyLocationId") || window.companyLocationId;

            if (!accessToken) return null;

            let companyLocationId = storedLocationId;
            if (companyLocationId && !`${companyLocationId}`.startsWith('gid://')) {
                companyLocationId = `gid://shopify/CompanyLocation/${companyLocationId}`;
            }

            const buyer = { customerAccessToken: accessToken };
            if (companyLocationId) {
                buyer.companyLocationId = companyLocationId;
            }

            return { buyer };
        } catch (e) {
            console.log('Error building buyer context', e);
            return null;
        }
    };

    try {
        let specialCol = document.querySelector('[data-default-col-card]')?.getAttribute('data-default-col-card');
        if (specialCol) {
            specialCol = specialCol.replace('collection-', '');
            document.querySelectorAll(`[data-col-handle=${specialCol}]:not(.collection-menu__item-sticky)`).forEach(ele => ele.classList.add('d-none'))
        }
    } catch (e) {
        console.log(e)
    }

    Utils.resetFilterBubbles = () => {
        document
            .querySelectorAll("filter-bubble")
            .forEach((filterBubble) => filterBubble.remove());
    };

    Utils.getAllQueryParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const paramsObj = {};
        queryParams.forEach((value, key) => {
            paramsObj[key] = value;
        });
        return paramsObj;
    };

    Utils.getQueryParam = (param) => {
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(param);
    };

    Utils.setQueryParam = (param, value) => {
        const queryParams = new URLSearchParams(window.location.search);
        const currentParamValue = Utils.getQueryParam(param);
        if (
            currentParamValue &&
            !param.includes("sort_by") &&
            !param.includes("filter.v.price")
        ) {
            const paramValuesArr = currentParamValue.split(",");
            paramValuesArr.push(value);
            queryParams.set(param, paramValuesArr.join(","));
        } else {
            queryParams.set(param, value);
        }
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        history.replaceState(null, null, newUrl);
        Utils.resetFilterBubbles();
        if (!Utils.isMobile()) {
            window.dispatchEvent(paramChangeEvent);
        }
    };

    Utils.removeQueryParam = (param, value) => {
        const queryParams = new URLSearchParams(window.location.search);
        let queryParamValues = [];
        const paramValues = Utils.getQueryParam(param);

        if (paramValues) {
            queryParamValues = paramValues.split(",");
            if (queryParamValues.length <= 1) {
                queryParams.delete(param);
            } else {
                const matchedFilterValueIndex = queryParamValues.findIndex(
                    (filterValue) => filterValue === value
                );
                queryParamValues.splice(matchedFilterValueIndex, 1);
                queryParams.set(param, queryParamValues.join(","));
            }
        }

        const newUrl = window.location.pathname + "?" + queryParams.toString();
        history.replaceState(null, null, newUrl);
        Utils.resetFilterBubbles();
        if (!Utils.isMobile()) {
            window.dispatchEvent(paramChangeEvent);
        }

    };

    Utils.resetQueryParam = (param) => {
        const url = new URL(window.location.href);
        url.searchParams.delete(param);
        window.history.replaceState(null, null, url);
    };

    Utils.formatFilterQuery = (filterStr) => {
        const replacements = {
            '"filters":': "filters:",
            '"variantOption"': "variantOption",
            '"name"': "name",
            '"value"': "value",
            '"available"': "available",
            "{filters": "filters",
            "]}": "]",
            '"namespace"': "namespace",
            '"key"': "key",
            '"productMetafield"': "productMetafield",
            '"tag"': "tag",
            '"price"': "price",
            '"min":"': "min:",
            '","max":"': ",max:",
        };
        return Object.entries(replacements).reduce(
            (acc, [pattern, replacement]) => acc.replaceAll(pattern, replacement),
            filterStr
        );
    };

    Utils.setImageUrlWidth = (imageUrl, width) => {
        return `${imageUrl}&width=${width}`;
    };

    Utils.formatMoney = (value) => {
        let cents = value * 100;
        let format = window.globalVariables.money_format || "${{ amount }}";
        if (typeof cents == "string") {
            cents = cents.replace(".", "");
        }
        let formattedValue = "";
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || (window.globalVariables && window.globalVariables.money_format);

        function defaultOption(opt, def) {
            return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ",");
            decimal = defaultOption(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            const parts = number.split("."),
                dollars = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    "$1" + thousands
                ),
                cents = parts[1] ? decimal + parts[1] : "";
            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                formattedValue = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                formattedValue = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                formattedValue = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                formattedValue = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
        return formatString.replace(placeholderRegex, formattedValue);
        // .replace(".00", "");
    };

    Utils.formatProductId = (productId) => {
        return productId.replaceAll("gid://shopify/Product/", "");
    };

    Utils.formatVariantId = (variantId) => {
        return variantId.replaceAll("gid://shopify/ProductVariant/", "");
    };

    Utils.formatSellingPlanId = (sellingPlanId) => {
        return sellingPlanId.replaceAll("gid://shopify/SellingPlan/", "");
    };

    Utils.capitalizeStr = (str) => {
        return str.replace(/\b\w/g, (letter) =>
            letter.toUpperCase()
        );
    };

    Utils.handleize = (str) => {
        return str.toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    Utils.renderCustomStars = (productDetails, wrapper) => {
        if (!wrapper) return;

        let ratingValue = productDetails.rating?.value || productDetails.okendoRating?.value;
        let countValue = productDetails.ratingCount?.value || productDetails.okendoRatingCount?.value;

        if (!ratingValue && !countValue) {
            wrapper.innerHTML = '';
            // If we have Okendo Snipet, let's use it
            if (productDetails.okendoSnippet?.value) {
                wrapper.innerHTML = productDetails.okendoSnippet.value;
            }
            return;
        }

        try {
            let rating = 0;
            let scaleMax = 5.0;
            let ratingCount = parseInt(countValue || 0);
            if (ratingValue) {
                const ratingData = JSON.parse(ratingValue);
                rating = parseFloat(ratingData.value || 0);
                scaleMax = parseFloat(ratingData.scale_max || 5.0);
            } else if (ratingCount > 0) {
                wrapper.setAttribute("data-oke-star-rating", "");
                wrapper.setAttribute("data-oke-reviews-product-id", "shopify-" + Utils.formatProductId(productDetails.id));
                if (window.okeWidgetApi) window.okeWidgetApi.initAllWidgets();
                return;
            }

            if (rating === 0 && ratingCount === 0) {
                wrapper.innerHTML = '';
                return;
            }

            const ratingPercent = (rating * 100) / scaleMax;
            const formattedCount = ratingCount >= 1000
                ? (Math.floor(ratingCount / 1000) + ',' + (ratingCount % 1000).toString().padStart(3, '0'))
                : ratingCount;

            wrapper.innerHTML = `
                <div class="custom-plp-rating">
                <svg id="oke-star-symbols" class="visually-hidden" style="display:none!important" data-oke-id="oke-star-symbols">
                <symbol id="oke-star-filled-sym" style="overflow:visible;">
                    <path id="star-thin--empty" fill="#000" stroke="#000" stroke-width="1" d="M9.944 6.4L8 0L6.056 6.4H0L4.944 9.928L3.064 16L8 12.248L12.944 16L11.064 9.928L16 6.4H9.944Z"></path>
                </symbol>
                <symbol id="oke-star-empty-sym" style="overflow:visible;">
                    <path id="star-thin--filled" fill="#fff" stroke="#000" stroke-width="1" d="M9.944 6.4L8 0L6.056 6.4H0L4.944 9.928L3.064 16L8 12.248L12.944 16L11.064 9.928L16 6.4H9.944Z"></path>
                </symbol>
            </svg>
                    <div class="star-container">
                        <div class="oke-stars-background">
                            <svg height="14" viewBox="0 0 94.76923076923077 16" aria-hidden="true" role="none">
                                <use x="0" href="#oke-star-empty-sym"></use>
                                <use x="19.692307692307693" href="#oke-star-empty-sym"></use>
                                <use x="39.38461538461539" href="#oke-star-empty-sym"></use>
                                <use x="59.07692307692308" href="#oke-star-empty-sym"></use>
                                <use x="78.76923076923077" href="#oke-star-empty-sym"></use>
                            </svg>
                        </div>
                        <div class="oke-stars-foreground" style="width: ${ratingPercent}%">
                            <svg height="14" viewBox="0 0 94.76923076923077 16" aria-hidden="true" role="none">
                                <use x="0" href="#oke-star-filled-sym"></use>
                                <use x="19.692307692307693" href="#oke-star-filled-sym"></use>
                                <use x="39.38461538461539" href="#oke-star-filled-sym"></use>
                                <use x="59.07692307692308" href="#oke-star-filled-sym"></use>
                                <use x="78.76923076923077" href="#oke-star-filled-sym"></use>
                            </svg>
                        </div>
                    </div>
                    <span class="rating-count">(${formattedCount})</span>
                </div>
            `;
        } catch (e) {
            wrapper.innerHTML = '';
        }
    };


    // GraphQL Query
    const refreshCustomerToken = async () => {
        const refreshToken = localStorage.getItem("customerRefreshAccessToken");
        if (!refreshToken) return null;

        try {
            const tokenResponse = await fetch("https://product-manager.woxer.com/api/customers/auth/refresh-token", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    client_id: "shp_06418bbb-8e60-4de1-b75d-2ffd234da00d",
                    refresh_token: refreshToken
                })
            });

            const tokenData = await tokenResponse.json();
            if (tokenData?.access_token) {
                window.customerAccessToken = tokenData.access_token;
                localStorage.setItem("customerAccessToken", tokenData.access_token);
                if (tokenData.refresh_token) {
                    localStorage.setItem("customerRefreshAccessToken", tokenData.refresh_token);
                }
                return tokenData.access_token;
            }
        } catch (e) {
            console.log("Customer token refresh failed", e);
        }

        return null;
    };

    const useQuery = async (query, variables = {}, hasRetried = false) => {
        query = query.replaceAll(
            "{{cursor_details}}",
            pageCursor ? `after: "${pageCursor}"` : ''
        ).replaceAll("{{product_count}}", 16)
            .replaceAll("{{product_count_main}}", 16);

        const buyerContext = getBuyerContextVariables();
        const finalVariables = {
            buyer: null,
            ...variables,
            ...(buyerContext || {})
        };

        const queryResponse = await fetch("/api/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Origin": "*",
                "X-Shopify-Storefront-Access-Token": "ee193b1539d2fbe0202bc6473e7682a8",
            },
            body: JSON.stringify({
                query,
                variables: finalVariables
            }),
        });

        const parsedResponse = await queryResponse.json();
        const hasSignatureExpired = parsedResponse?.errors?.some(
            (error) => typeof error?.message === "string" && error.message.toLowerCase().includes("signature has expired")
        );

        if (hasSignatureExpired && !hasRetried) {
            const refreshedToken = await refreshCustomerToken();
            if (refreshedToken) {
                return await useQuery(query, variables, true);
            }
        }

        return parsedResponse;
    };

    Utils.getListFilterSwatch = (filterDetails, value) => {
        if (filterDetails.label === 'Size') {

            // Old structure
            const filterValueLabel = document.createElement("label");
            const currentParamValue = Utils.getQueryParam(filterDetails.id);
            if (currentParamValue) {
                const currentParamValueArr = currentParamValue.split(",");
                if (currentParamValueArr.includes(value.label)) {
                    filterValueLabel.classList.add("active");
                }
            }
            filterValueLabel.classList.add("filter-swatch");
            filterValueLabel.setAttribute('role', 'button');
            filterValueLabel.dataset.filterId = filterDetails.id;
            filterValueLabel.dataset.value = value.label;

            filterValueLabel.addEventListener("click", () => {
                const filterParam = Utils.getQueryParam(filterDetails.id);
                let filterParamsArr = [];
                if (filterParam) {
                    filterParamsArr = filterParam.split(",");
                }
                const filterValue = filterValueLabel.dataset.value;
                if (filterParamsArr.includes(filterValue)) {
                    Utils.removeQueryParam(filterDetails.id, filterValue);
                } else {
                    Utils.setQueryParam(filterDetails.id, filterValue);
                }

                if (Utils.isMobile()) {
                    filterValueLabel.classList.toggle("active");
                }
            });

            const labelText = document.createElement("span");
            labelText.innerText = value.label;
            filterValueLabel.title = value.label;
            filterValueLabel.append(labelText);

            return filterValueLabel;

        } else if (filterDetails?.label) {
            // Checkbox structure
            const filterValueLabel = document.createElement("label");
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.name = filterDetails.id;
            checkbox.value = filterDetails.id === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value) : value.label;
            if (checkbox && filterDetails) {
                const currentParamValue = Utils.getQueryParam(filterDetails.id);
                if (currentParamValue) {
                    const currentParamValueArr = currentParamValue.split(",");
                    if (currentParamValueArr.includes(value.label)) {
                        filterValueLabel.classList.add("active");
                    }
                }
            }

            const currentParamValue = Utils.getQueryParam(filterDetails.id);
            if (currentParamValue) {
                const currentParamValueArr = currentParamValue.split(",");
                if (currentParamValueArr.includes(value.label)) {
                    checkbox.checked = true;
                }
            }

            filterValueLabel.classList.add("filter-checkbox");
            filterValueLabel.dataset.filterId = filterDetails.id;

            if (filterDetails.id.includes("color")) {
                filterValueLabel.classList.add("filter-color");
                filterValueLabel.style.order = value.label.length;

                const swatchCircle = document.createElement("div");
                swatchCircle.classList.add("swatch-circle");
                swatchCircle.innerHTML = `<span class="hide">${value.label}</span>`;

                const matchedColorSetting = filterColorSettings.find(
                    (color) => color.colorName.toLowerCase() === value.label.toLowerCase()
                );
                const matchedColorImageSetting = filterColorImageSettings.find(
                    (color) => color.colorName.toLowerCase() === value.label.toLowerCase()
                );

                if (matchedColorSetting) {
                    swatchCircle.style.backgroundColor = matchedColorSetting.colorHexValue;
                } else {
                    if (matchedColorImageSetting) {
                        const baseUrl = document.querySelector('[data-file-url-base]').dataset.fileUrlBase;
                        const swatchUrl = baseUrl.replace('multi_small.jpg', matchedColorImageSetting.colorImage).replace('127.0.0.1:9292', 'woxer.com');
                        swatchCircle.style.backgroundImage = `url(${Utils.setImageUrlWidth(swatchUrl, 31)})`;
                    } else {
                        const baseUrl = document.querySelector('[data-file-url-base]').dataset.fileUrlBase;
                        const swatchUrl = baseUrl.replace('multi', value.label.toLowerCase().replaceAll(' ', '-')).replace('127.0.0.1:9292', 'woxer.com');
                        swatchCircle.style.backgroundImage = `url(${Utils.setImageUrlWidth(swatchUrl, 31)})`;
                    }
                }
                filterValueLabel.append(swatchCircle);
            }

            checkbox.addEventListener("change", () => {
                const filterParam = Utils.getQueryParam(filterDetails.id);
                let filterParamsArr = [];
                if (filterParam) {
                    filterParamsArr = filterParam.split(",");
                }
                const filterValue = checkbox.value;

                if (filterParamsArr.includes(filterValue)) {
                    Utils.removeQueryParam(filterDetails.id, filterValue);
                } else {
                    Utils.setQueryParam(filterDetails.id, filterValue);
                }

                if (Utils.isMobile()) {
                    filterValueLabel.classList.toggle("active");
                }
            });

            const labelText = document.createElement("span");
            labelText.classList.add('label-text');
            const labelTextAB = document.createElement("span");
            labelTextAB.classList.add('ab-label-text');

            // Temp Fix Rename Some Filters
            if (value.label === "Baller Flex") {
                value.label = "Baller 5\" Flex Boxers";
            } else if (value.label === "Biker Flex") {
                value.label = "Biker 9\" Flex Boxers";
            } else if (value.label === "Baller Fly 5\"") {
                value.label = "Baller 5\" Boxers w/ Fly";
            } else if (value.label === "Baller Fly 7\"") {
                value.label = "Baller 7\" Boxers w/ Fly";
            } else if (value.label === "Biker High Waisted") {
                value.label = "Biker 9\" High Waisted Boxers";
            } else if (value.label === "Boss Flex") {
                value.label = "Boss Flex Sports Bra";
            } else if (value.label === "Icon 2.0") {
                value.label = "Icon Slim Brallete";
            } else if (value.label === "Star High Waisted") {
                value.label = "Star 3” High Waisted";
            }

            labelText.innerText = value.label;

            if (value.label === "Baller 5\" Flex Boxers") {
                value.label = "Baller Flex";
            } else if (value.label === "Biker 9\" Flex Boxers") {
                value.label = "Biker Flex";
            } else if (value.label === "Baller 5\" Boxers w/ Fly") {
                value.label = "Baller Fly 5\"";
            } else if (value.label === "Baller 7\" Boxers w/ Fly") {
                value.label = "Baller Fly 7\"";
            } else if (value.label === "Biker 9\" High Waisted Boxers") {
                value.label = "Biker High Waisted";
            } else if (value.label === "Boss Flex Sports Bra") {
                value.label = "Boss Flex";
            } else if (value.label === "Icon Slim Brallete") {
                value.label = "Icon 2.0";
            } else if (value.label === "Star 3” High Waisted") {
                value.label = "Star High Waisted";
            }

            const nameMap = {
                "Baller": "5” Boxer Brief",
                "Star": "3” Boxer Brief",
                "Biker": "9” Boxer Brief",
                "Baller High Waisted": "5” High Waisted",
                "Biker High Waisted": "9” High Waisted",
                "Baller Fly 5\"": "5” Boxer Brief w/ Fly",
                "Baller Flex": "5” Active Boxer Brief",
                "Baller Fly 7\"": "7” Boxer Brief w/ Fly",
                "Bold": "Boyshorts",
                "Classic": "Briefs",
                "Dreamer": "Boxer w/ Pockets",
                "Baller Pad Liner": "5” Boxer w/ Pad Liner",
                "Baller Luxe": "5” Luxe Boxer Brief",
                "Baller Rib": "5” Ribbed Boxer Brief",
                "Bold Luxe": "Luxe Boyshorts",
            };

            labelTextAB.innerText = nameMap[value.label?.trim()] || value.label;

            filterValueLabel.title = value.label;
            filterValueLabel.append(checkbox, labelText, labelTextAB);
            filterValueLabel.dataset.value = filterDetails.id === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value) : value.label;

            return filterValueLabel;
        }
    };

    Utils.updateSortingElements = () => {
        const sortByValue = Utils.getQueryParam("sort_by");
        if (sortByValue) {
            document
                .querySelectorAll(".sort-by-list button")
                .forEach((btn) => btn.classList.remove("active"));
            const matchedListElement = document.querySelector(
                `.sort-by-list button[data-value="${sortByValue}"]`
            );
            if (matchedListElement) {
                matchedListElement.classList.add("active");
                const desktopTrigger = document.querySelector(".collections-bundles__sort-by-trigger span");
                if (desktopTrigger) {
                    desktopTrigger.innerText = `Sort by ${matchedListElement.innerText.trim()}`;
                }
            }

            // Update mobile sorting elements
            document.querySelectorAll('.sort-by-list-filters button').forEach(mobileBtn => {
                mobileBtn.classList.remove('active');
            });
            const matchedMobileElement = document.querySelector(`.sort-by-list-filters button[data-value="${sortByValue}"]`);
            if (matchedMobileElement) {
                matchedMobileElement.classList.add('active');
            }
        }
    };

    Utils.resetQueryParams = () => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams();
        url.search = params.toString();

        window.history.replaceState({}, document.title, url.toString());


        /*if (document.querySelector('[data-new-collection-structure]')) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            const spCollection = params.get("sp_collection");
            const newParams = new URLSearchParams();

            if (spCollection) {
                newParams.set("sp_collection", spCollection);
            }

            url.search = newParams.toString();
            window.history.replaceState({}, document.title, url.toString());
        } else {
            const url = new URL(window.location.href);
            const params = new URLSearchParams();
            url.search = params.toString();

            window.history.replaceState({}, document.title, url.toString());
        }*/
    };

    const extraLabelSettings = JSON.parse(
        document.getElementById("extra-label-settings")?.innerText || "{}"
    );

    const getExtraLabelText = (key, fallback) => {
        const customValue = extraLabelSettings?.[key];
        if (typeof customValue === 'string' && customValue.trim().length > 0) {
            return customValue.trim();
        }
        return fallback;
    };

    Utils.getOfferSettings = (productDetails = null, priceValue = 0) => {
        let productTags = productDetails?.tags
        let offerApplied = true;
        let offerLabelColor = '#fff';
        let offerLabelBackground = '#000';
        let offerLabelColorExtra = '#fff';
        let offerLabelBackgroundExtra = '#a0ec96';
        let offerStrokeColor = '#000';
        let offerPrice = priceValue;
        let offerPrice_ab = priceValue;
        let originalPriceB2B = priceValue;
        let offerPrice_vip = priceValue;
        let displayedPrice = '';
        let offerLabel = '';
        let offerLabelAB = '';
        let priceOfferLabel = '';
        let extraLabel = '';
        let badgeClass = '';
        const lowStockLabel = getExtraLabelText('lowStockLabel', 'LOW STOCK');
        const newColorsLabel = getExtraLabelText('newColorsLabel', 'NEW COLORS');
        const lowStockLimit = getExtraLabelText('lowStockLimit', '30');
        const bestSellerLabel = getExtraLabelText('bestSellerLabel', 'BEST SELLER');
        const secondaryBadgeColor = getExtraLabelText('badgeColor', '#fffff');
        const secondaryBadgeBgColor = getExtraLabelText('badgeBgColor', '#C9CDCC');
        const enableSecondaryBadge = getExtraLabelText('enabledExtraLabel', false);

        if (productTags.includes('MD40-2026')) {
            offerLabel = '40% OFF';
            offerLabelAB = offerLabel;
            offerPrice = priceValue * 0.60;
            offerPrice_ab = priceValue * 0.60;
            offerLabelBackgroundExtra = '#A2242F';
            badgeClass = 'memorial_badge'
            displayedPrice = `<span class="d-flex flex-column">
                                <span class="new_offer_design offer-tagline d-flex flex-column" style="gap: 0 !important;">
                                    <div class="d-flex align-items-center" style="gap:6px">
                                        <span>{strike_price}</span>
                                        <span class="memo-sale-color">{offer_price}</span>
                                    </div>
                                    <div class="black-offer-line text-black memo-bg-color mt-1" style="min-width: unset !important;">SALE</div>
                                </span>
                            </span>`;
        } else if (productTags.includes('MD20-2026')) {
            offerLabel = '20% OFF';
            offerLabelAB = offerLabel;
            offerPrice = priceValue * 0.80;
            offerPrice_ab = priceValue * 0.80;
            offerLabelBackgroundExtra = '#A2242F';
            badgeClass = 'memorial_badge'
            displayedPrice = `<span class="d-flex flex-column">
                                <span class="new_offer_design offer-tagline d-flex flex-column" style="gap: 0 !important;">
                                    <div class="d-flex align-items-center" style="gap:6px">
                                        <span>{strike_price}</span>
                                        <span class="memo-sale-color">{offer_price}</span>
                                    </div>
                                    <div class="black-offer-line text-black memo-bg-color mt-1" style="min-width: unset !important;">SALE</div>
                                </span>
                            </span>`;
        } else if (productTags.includes('MD30-2026')) {
            offerLabel = '30% OFF';
            offerLabelAB = offerLabel;
            offerPrice = priceValue * 0.70;
            offerPrice_ab = priceValue * 0.70;
            offerLabelBackgroundExtra = '#A2242F';
            badgeClass = 'memorial_badge'
            displayedPrice = `<span class="d-flex flex-column">
                                <span class="new_offer_design offer-tagline d-flex flex-column" style="gap: 0 !important;">
                                    <div class="d-flex align-items-center" style="gap:6px">
                                        <span>{strike_price}</span>
                                        <span class="memo-sale-color">{offer_price}</span>
                                    </div>
                                    <div class="black-offer-line text-black memo-bg-color mt-1" style="min-width: unset !important;">SALE</div>
                                </span>
                            </span>`;
        } else if (['GIFTCARD'].some(tag => productTags.includes(tag))) {
            displayedPrice = "<span class=\"d-flex flex-column\">\n<span class=\"new_offer_design offer-tagline d-flex align-items-center\">{price} - {end_price}</span></span>";
        } else {
            displayedPrice = "<span class=\"b2b-offer-helper-wrapper\"><span class=\"b2b_price strike-price\">{price_b2b}</span><span class=\"normal_price offer-price\">{price}</span></span> <span class=\"d-flex flex-column col_normal_offer_content\">\n<span class=\"new_offer_design offer-tagline d-flex align-items-center\">{price}</span></span>";
        }

        if (enableSecondaryBadge === 'true' || enableSecondaryBadge === true) {
            let labelTag = productTags.find(tag => tag.includes("label-"));
            let colorValue = productDetails?.options?.find(opt => opt.name === "Color")?.values[0]?.trim() || '';
            let totalInventory = productDetails.totalInventory;
            const bestSellerColors = ["Black 2.0"];
            const publishedAt = productDetails?.publishedAt;
            let isWithinLastTwoWeeks = false;
            if (publishedAt) {
                const diffMs = new Date() - new Date(publishedAt);
                const twoWeeksMs = 14 * 24 * 60 * 60 * 1000;
                isWithinLastTwoWeeks = diffMs <= twoWeeksMs && diffMs >= 0;
            }

            if (totalInventory < parseInt(lowStockLimit) && !productTags.includes('PACK') && !productTags.includes('GIFTCARD')) {
                extraLabel = lowStockLabel;
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (isWithinLastTwoWeeks) {
                extraLabel = newColorsLabel;
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;

                if (productTags.includes('EXTRAGALACTIC-2026_RELEASE')) {
                    extraLabel = 'RESTOCK';
                }
            }

            if (labelTag) {
                extraLabel = labelTag.replace("label-", "").trim();
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (bestSellerColors.includes(colorValue)) {
                extraLabel = bestSellerLabel;
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (productTags.includes('PADLINER_RELEASE')) {
                extraLabel = 'PAD LINER';
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (productTags.includes('ws-win_baller')) {
                extraLabel = 'FLOATING GUSSET';
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (productTags.includes('FLUID-2026_RELEASE')) {
                extraLabel = 'PERIOD PROTECTION';
                offerLabelColorExtra = productDetails?.extraLabelColor?.value || secondaryBadgeColor;
                offerLabelBackgroundExtra = productDetails?.extraLabelBackground?.value || secondaryBadgeBgColor;
            }

            if (productTags.includes('MD40-2026')) {
                extraLabel = '40% OFF';
                offerLabelColorExtra = '#fff';
                offerLabelBackgroundExtra = '#A2242F';
            }
            if (productTags.includes('MD20-2026')) {
                extraLabel = '20% OFF';
                offerLabelColorExtra = '#fff';
                offerLabelBackgroundExtra = '#A2242F';
            }
            if (productTags.includes('MD30-2026')) {
                extraLabel = '30% OFF';
                offerLabelColorExtra = '#fff';
                offerLabelBackgroundExtra = '#A2242F';
            }
        }

        return {
            offerApplied,
            offerPrice,
            offerPrice_ab,
            displayedPrice,
            offerLabel,
            offerLabelAB,
            priceOfferLabel,
            offerLabelColor,
            offerLabelBackground,
            offerStrokeColor,
            badgeClass,
            offerPrice_vip,
            originalPriceB2B,
            extraLabel,
            offerLabelColorExtra,
            offerLabelBackgroundExtra
        };
    }

    Utils.updateFilterOptions = () => {
        let processedOption = [];
        document.querySelectorAll("filter-option").forEach((filterOption) => {
            const activeOptions = filterOption.querySelectorAll('.filter-option__values .active')?.length;

            if (!processedOption.includes(filterOption.getAttribute('filter-id'))) {
                let filterLabel = filterOption.getAttribute('filter-details');
                filterLabel = JSON.parse(filterLabel).label;
                filterOption.querySelector('.filter-option__title').innerText = `${filterLabel} ${activeOptions ? `(${activeOptions})` : ``} `
                processedOption.push(filterOption.getAttribute('filter-id'))
            }
        });
    }

    Utils.isInViewport = (el, percentVisible) => {
        let rect = el.getBoundingClientRect(),
            windowHeight = window.innerHeight || document.documentElement.clientHeight,
            windowWidth = window.innerWidth || document.documentElement.clientWidth;

        const headerHeight = document.querySelector('sticky-header .site-header')?.offsetHeight - 10;

        return !(
            Math.floor(100 - (((rect.top - headerHeight) >= 0 ? 0 : (rect.top - headerHeight)) / -rect.height) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.bottom - headerHeight - windowHeight) / rect.height) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.left >= 0 ? 0 : rect.left) / -rect.width) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.right - windowWidth) / rect.width) * 100) <
            percentVisible
        );
    };

    Utils.renderCardPrice = (
        productDetails,
        priceWrapper,
        priceValue,
        templateContent
    ) => {

        priceValue = parseFloat(priceValue) * canadaRate;

        let {
            offerApplied,
            offerPrice,
            offerPrice_ab,
            displayedPrice,
            offerLabel,
            offerLabelAB,
            priceOfferLabel,
            offerLabelColor,
            offerLabelBackground,
            offerStrokeColor,
            badgeClass,
            offerPrice_vip,
            originalPriceB2B,
            extraLabel,
            offerLabelColorExtra,
            offerLabelBackgroundExtra
        } = Utils.getOfferSettings(productDetails, priceValue);

        let percentageDiscount = '30';
        let isBoxerProduct = productDetails?.tags?.includes("BOXERS_RELEASE");
        if (productDetails?.tags?.includes("ws-boxytee") || productDetails?.tags?.includes("ws_handband")) {
            isBoxerProduct = true;
        }

        if (productDetails?.tags?.includes("5PACK")) {
            // displayedPrice = displayedPrice.replaceAll('{offer_price}', `<span class="sale-price">${Utils.formatMoney(Math.round(offerPrice))}</span>`);
        }

        displayedPrice = displayedPrice.replaceAll('{price}', `<span class="regular-price">${Utils.formatMoney(priceValue)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{end_price}', `<span class="regular-price">${Utils.formatMoney(150.00)}</span>`); //TODO: Temp gift-card pricing (quick fix for urgency)
        displayedPrice = displayedPrice.replaceAll('{price_b2b}', `<span class="regular-price">${Utils.formatMoney(originalPriceB2B)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{offer_price}', `<span class="sale-price">${Utils.formatMoney(offerPrice)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{offer_price_ab}', `<span class="sale-price">${Utils.formatMoney(offerPrice_ab)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{offer_discount}', percentageDiscount);
        displayedPrice = displayedPrice.replaceAll('{strike_price}', `<span class="crossed-price">${Utils.formatMoney(priceValue)}</span>`);

        const sellingPlanAllocations = productDetails.variants?.edges[0]?.node?.sellingPlanAllocations || [];
        let sellingPlanPrice = 0;
        let sellingPlan = sellingPlanAllocations.edges?.[0];
        if (sellingPlan && sellingPlan.node) {
            sellingPlanPrice = sellingPlan.node.priceAdjustments[0].price.amount;
            displayedPrice = displayedPrice.replaceAll('{subscription_price}', `<span class="subscription-price ${isBoxerProduct ? 'd-none' : ''}">${Utils.formatMoney(sellingPlanPrice * canadaRate)}`);
        } else {
            displayedPrice = displayedPrice.replaceAll('{subscription_price}', ``).replaceAll('Subscribers', ``);
        }

        priceWrapper.innerHTML = displayedPrice;

        let badgePosition = 'bottom';
        if (
            offerApplied
            && Shopify.country !== 'CA'
            && Shopify.country !== 'GB'
            && Shopify.country !== 'AU'
            && Shopify.country !== 'NZ'
            && Shopify.country !== 'AT'
        ) {
            if (priceOfferLabel.length > 0) {
                let offerBadgeElement = document.createElement("span");
                offerBadgeElement.classList.add('badge', 'offer-badge', badgePosition)
                offerBadgeElement.innerHTML = priceOfferLabel
                offerBadgeElement.style.color = offerLabelColor
                offerBadgeElement.style.backgroundColor = offerLabelBackground;
                offerBadgeElement.style.borderColor = offerStrokeColor;
                priceWrapper.append(offerBadgeElement);
            }

            if (
                templateContent
                && templateContent.querySelector('[data-plp-sale-tag]')
                && offerLabel.length > 0
            ) {
                templateContent.querySelector('[data-plp-sale-tag]').innerHTML = offerLabel;
                templateContent.querySelector('[data-plp-sale-tag]')?.classList?.remove('d-none');
                if (badgeClass) templateContent.querySelector('[data-plp-sale-tag]')?.classList?.add(badgeClass);
            }

            if (
                templateContent
                && templateContent.querySelector('[data-plp-sale-tag-ab]')
                && offerLabelAB.length > 0
            ) {
                templateContent.querySelector('[data-plp-sale-tag-ab]').innerHTML = offerLabelAB;
                templateContent.querySelector('[data-plp-sale-tag-ab]')?.classList?.remove('d-none');
                if (badgeClass) templateContent.querySelector('[data-plp-sale-tag-ab]')?.classList?.add(badgeClass);
            }

            if (templateContent && templateContent.querySelector('.product-card__labels')) {
                let extraLabelEle = templateContent.querySelector('.product-card__labels');
                extraLabelEle.innerHTML = extraLabel || ''
                extraLabelEle.style.color = offerLabelColorExtra;
                extraLabelEle.style.backgroundColor = offerLabelBackgroundExtra;
                extraLabelEle.style.borderColor = offerLabelBackgroundExtra;
            }
        }
    };

    Utils.isMobile = () => {
        const width = window.innerWidth;

        return width <= 769;
    };

    const facetsTitle = document.querySelector('.collection-facets-title > span');
    if (Utils.isMobile()) {
        facetsTitle.innerText = 'Filters';
    }

    const html = document.querySelector('html');

    // Collection text section
    const readMoreBtn = document.querySelector(".collection-text-read-more");
    if (readMoreBtn) {
        readMoreBtn.addEventListener("click", () => {
            const sectionWrapper = readMoreBtn.closest(".collection-text");
            const collectionTextWrapper = sectionWrapper.querySelector(
                ".collection-text__wrapper"
            );
            collectionTextWrapper.classList.toggle("collapse");
        });
    }

    // Mobile filter
    const mobileFilterToggles = document.querySelectorAll(".filter-mobile-toggle");
    const filtersWrapper = document.querySelector(".collection-facets-wrapper");
    mobileFilterToggles.forEach(ele => ele.addEventListener("click", () => {
        document.querySelectorAll('.collection-facets__filter-options filter-option, .collection-facets__filter-options .sort-by-filters')
            .forEach(ele => ele.classList.add('close'))
        filtersWrapper.classList.add("open");
        html.classList.add("open");
    }))

    const mobileFilterCloseBtns = document.querySelectorAll(
        ".facets-mobile-close"
    );

    mobileFilterCloseBtns.forEach((closeBtn) => {
        closeBtn.addEventListener("click", () => {
            filtersWrapper.classList.remove("open");
            html.classList.remove("open");
        });
    });

    const mobileFilterApplyButton = document.querySelector('.filter-view-products');
    mobileFilterApplyButton.addEventListener("click", () => {
        window.dispatchEvent(paramChangeEvent);
        filtersWrapper.classList.remove("open");
        html.classList.remove("open");
    })

    // Global selectors
    const collectionsElements = Array.from(
        document.querySelectorAll(".collection-bundle:not(.d-none)")
    );

    /*    const collectionOverlay = document.querySelector(".collection-overlay");
        if (collectionOverlay) {
            collectionOverlay.addEventListener('click', () => {
                document.querySelector('.collection-facets-wrapper').classList.remove('open');
                html.classList.remove('open');
            });
        }*/

    const filterColorSettings = JSON.parse(
        document.getElementById("filter-color-settings").innerText
    );

    const filterColorImageSettings = JSON.parse(
        document.getElementById("filter-color-image-settings").innerText
    );

    const filterSortingSettings = JSON.parse(
        document.getElementById("filter-sorting-settings").innerText
    );

    const subFilterSortingSettings = JSON.parse(
        document.getElementById("sub-filter-sorting-settings").innerText
    );

    const paramChangeEvent = new CustomEvent("paramchange", {
        detail: {
            message: "Parameter Change",
        },
    });

    // Global setting
    const productCardImageWidth = 460;

    window.defaultScrollEffect = false;
    // Event listeners
    /*document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => {
        ele.addEventListener('click', (event) => {
            if (!event.target.closest('img')) {
                return;
            }
            document.querySelectorAll('.filter-option__values label[data-value="4 Pack"]:not(.disabled):not(.active), ' +
                '.filter-option__values label[data-value="6 Pack"]:not(.disabled):not(.active), ' +
                '.filter-option__values label[data-value="10 Pack"]:not(.disabled):not(.active)')
                .forEach(ele => {
                    ele.click();
                })
            window.scrollTo({
                top: 700,
                behavior: "smooth"
            })
        })
    })*/

    /*document.querySelectorAll('[data-plp-filter-card]:not([data-plp-new-structure-card])').forEach(ele => {
        ele.addEventListener('click', () => {
            let element = ele.closest('[data-plp-filter-card]')
            let filterValue = element.getAttribute('data-plp-filter-card');
            document.querySelector(`.filter-option__values label[data-value="${filterValue}"]:not(.disabled):not(.active)`)?.click();
            window.scrollTo({
                top: document.querySelector('.collection-product-list')
                    ? (document.querySelector('.collection-product-list')?.offsetTop - 100)
                    : 0
            })
        })
    })*/

    let isDragging = false;
    try {
        const colSliders = document.querySelectorAll('.collection-menu__items .swiper-slider');
        colSliders.forEach((colSlider) => {
            let downX = 0, downY = 0;

            colSlider.addEventListener('pointerdown', (e) => {
                isDragging = false;
                downX = e.clientX ?? 0;
                downY = e.clientY ?? 0;
            }, { passive: true });

            colSlider.addEventListener('pointermove', (e) => {
                const dx = Math.abs((e.clientX ?? 0) - downX);
                const dy = Math.abs((e.clientY ?? 0) - downY);
                if (dx > 5 || dy > 5) isDragging = true;
            }, { passive: true });

            colSlider.addEventListener('pointerup', () => {

            }, { passive: true });
        });
    } catch (e) {
        console.log(e, 'error from slider')
    }
    document.querySelectorAll('[data-plp-new-structure-card]:not(.redirect)').forEach(ele => {
        ele.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            let stickyBtnClick = true;
            if (isDragging) {
                isDragging = false;
                return;
            }
            loadinSpecialCollection = true;
            let element = event.target.closest('[data-plp-new-structure-card]');
            let newValue = element.getAttribute('data-plp-new-structure-card');

            document.querySelectorAll('[data-plp-new-structure-products]').forEach(ele => ele.classList.add('d-none'));
            document.querySelector(`[data-plp-new-structure-products="${newValue}"]`)?.classList?.remove('d-none');

            history.replaceState(null, null, `${window.location.origin}/collections/${newValue.replace('collection-', '')}`);
            syncSaleFilter(); // URL no longer has filter.p.tag — uncheck sale filter immediately

            if (document.querySelector('[data-final-breadcrumb]')) {
                let breadTitle = element?.getAttribute('data-card-title') || element?.getAttribute('data-link-text');
                breadTitle = breadTitle?.replace('All Underwear', '')?.replace('Shop All Bralettes & Tops', '')?.replace('Shop All Tops', '');
                if (breadTitle) {
                    document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                    document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.remove('d-none'));
                } else {
                    document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle || '');
                    document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.add('d-none'));
                }
            }

            // adjustBreadcrumbs();
            pageCursor = '';
            renderCollection(getCollectionQuery());
            document.querySelectorAll('.collection-menu__items .collection-menu__item')?.forEach(ele => ele.classList.remove('d-none'));
            event.target.closest('.collection-menu__items .collection-menu__item')?.classList.add('d-none');

            if (!ele.closest('.collection-menu__item-sticky')) {
                ele = document.querySelector(`.collection-menu__item-sticky [data-plp-new-structure-card="${newValue}"]`);
                stickyBtnClick = false;
            }
            if (ele.closest('.collection-menu__item-sticky')) {
                const activeSticky = ele.closest('.collection-menu__item-sticky');
                document.querySelector('.collection-menu__item-sticky.active')?.classList.remove('active');
                activeSticky?.classList.add('active');
                let stickyContainer = activeSticky.closest('ul');
                if (stickyContainer) {
                    const offset =
                        activeSticky.offsetLeft -
                        stickyContainer.clientWidth / 2 +
                        activeSticky.clientWidth / 2;

                    stickyContainer.scrollTo({
                        left: offset
                    });
                }

                if (document.querySelector('.topcard-3-variation')) {
                    let activeTopCard = document.querySelector('.ab-test-topcard .plp_new_structure.collection-menu__item.d-none');
                    let activeTopcardContainer = activeTopCard?.closest('.swiper-wrapper');
                    if (activeTopCard && activeTopcardContainer) {
                        const offset =
                            activeTopCard.offsetLeft -
                            activeTopcardContainer.clientWidth / 2 +
                            activeTopCard.clientWidth / 2;

                        activeTopcardContainer.scrollTo({
                            left: offset
                        });
                    }
                }

                const wrappers = document.querySelectorAll(".collection-menu__items .swiper-wrapper");
                let selectedTopCard = document.querySelector(`.collection-menu__item_v2:has([data-plp-new-structure-card=${newValue}])`);
                if (selectedTopCard && stickyBtnClick) {
                    wrappers.forEach((wrapper) => {
                        if (!wrapper.contains(selectedTopCard)) return;
                        const wrapperRect = wrapper.getBoundingClientRect();
                        const cardRect = selectedTopCard.getBoundingClientRect();
                        const scrollLeft =
                            wrapper.scrollLeft +
                            (cardRect.left - wrapperRect.left) -
                            (wrapperRect.width / 2 - cardRect.width / 2);
                        wrapper.scrollTo({ left: scrollLeft });
                    });
                }
            }
        })
    })

    const clearAllButtons = document.querySelectorAll(".filter-clear-all");
    clearAllButtons.forEach((clearALlBtn) => {
        clearALlBtn.addEventListener("click", () => {
            Utils.resetQueryParams();
            window.dispatchEvent(paramChangeEvent);
            if (window.innerWidth <= 768) {
                filtersWrapper?.classList.remove("open");
                html.classList.remove("open");
            }
        });
    });

    const attachFiltersEvents = (filterOption) => {
        // Collapsible Toggle
        const filterOptionToggle = filterOption.querySelector(
            ".filter-option__toggle"
        );

        filterOptionToggle.addEventListener("click", () => {
            if (filterOption.closest(".style_filter_option") && document.querySelector('body:has(.jumplink_ab_new)')) {
                filterOption.classList.remove("style_filter_option");
            } else {
                filterOption.classList.toggle("close");
            }
            const filterOptionElement = filterOption.closest('filter-option');
            const filterValues = filterOptionElement.querySelector('.filter-option__values');
            if (Utils.isMobile()) {
                filterValues.scrollIntoView({ behavior: 'smooth' });
            }
            let filterContainer = document.querySelector(".collection-facets-wrapper");
            let moreFilterArrow = document.querySelector('.collection-product-list .filter_scroll_down');
            if (moreFilterArrow && !Utils.isMobile()) {
                if (isScrollableVertically(filterContainer)) {
                    moreFilterArrow?.classList?.add('d-none');
                } else {
                    moreFilterArrow?.classList?.add('d-none');
                }

                let isScrollToBottom = false;

                function scrollToBottom() {
                    filterContainer.scrollTop = filterContainer.scrollHeight;
                }

                function scrollToTop() {
                    filterContainer.scrollTop = 0;
                }

                function toggleScroll() {
                    if (isScrollToBottom) {
                        scrollToTop();
                        moreFilterArrow.style.transform = `rotate(0deg)`
                    } else {
                        scrollToBottom();
                        moreFilterArrow.style.transform = `rotate(180deg)`
                    }
                    isScrollToBottom = !isScrollToBottom;
                }

                moreFilterArrow.addEventListener('click', toggleScroll);
            }
        });
    };

    const attachProductCardsEvents = (productCard) => {
        const productMediaAction = productCard.querySelector('.product-card__media-action');
        productMediaAction.addEventListener('click', () => {
            productCard.querySelector('.product-card__url').click();
        });
    };

    // Sort by events
    const sortBySelector = document.querySelector(
        ".collections-bundles__sort-by-selector"
    );
    sortBySelector.addEventListener("change", function () {
        Utils.setQueryParam("sort_by", this.value);
        Utils.updateSortingElements();
    });

    const sortByListBtns = document.querySelectorAll(".sort-by-list button");
    sortByListBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const sortingValue = btn.dataset.value;
            const masterSelector = document.querySelector(
                ".collections-bundles__sort-by-selector"
            );
            masterSelector.value = sortingValue;
            const changeEvent = new Event("change");
            masterSelector.dispatchEvent(changeEvent);
            document.querySelector(".sort-by-list").classList.toggle("hide");
            document
                .querySelector(".collections-bundles__sort-by-trigger")
                .classList.toggle("open");
        });
    });

    const sortListTrigger = document.querySelector(
        ".collections-bundles__sort-by-trigger"
    );
    sortListTrigger.addEventListener("click", () => {
        sortListTrigger.classList.toggle("open");
        document.querySelector(".sort-by-list").classList.toggle("hide");
    });

    document.addEventListener("click", function (event) {
        const elem = document.querySelector(".sort-by-wrapper");
        const outsideClick = !elem.contains(event.target);
        if (outsideClick) {
            document.querySelector(".sort-by-list").classList.add("hide");
            document.querySelector('.collections-bundles__sort-by-trigger').classList.remove('open');
        }
    });

    // Sort by filters mobile
    document.querySelectorAll('.sort-by-list-filters button').forEach(btn => {
        btn.addEventListener('click', () => {
            // Reset buttons
            document.querySelectorAll('.sort-by-list-filters button').forEach(sortBtn => sortBtn.classList.remove('active'));
            sortBySelector.value = btn.dataset.value;
            const changeEvent = new Event("change");
            sortBySelector.dispatchEvent(changeEvent);
            btn.classList.add('active');
        });
    });

    document.querySelector('.sort-by-filters__trigger').addEventListener('click', function () {
        const sortByWrapper = this.closest('.sort-by-filters');
        sortByWrapper.classList.toggle('close');
    });

    // Web Components
    class ProductColorSwatch extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
        }

        connectedCallback() {
            const templateInstance = document.getElementById("product-color-swatch-template");
            const templateContent = templateInstance.content.cloneNode(true);

            // Use JS map to get details
            const siblingProductId = this.getAttribute("sibling-product-id");
            const swatchProductDetails = swatchSiblingProductDetailsMap.get(siblingProductId);
            const swatchImageElement = templateContent.querySelector(
                ".product-swatch__image"
            );
            const swatchImageTitle = swatchProductDetails.node.title;
            const swatchImageTag = swatchProductDetails.node.tags;

            swatchImageElement.innerHTML = `<span class="hide-display">${swatchImageTitle}</span>`;

            if (swatchImageTag?.includes('WSINGLES')) {
                swatchImageElement.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image'), 60)}")`;
            } else {
                swatchImageElement.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image'), 60)}")`;
                swatchImageElement.classList.add('pack_pd_swatch')
            }
            swatchImageElement.setAttribute("title", swatchImageTitle);
            swatchImageElement?.setAttribute("data-link-text", swatchImageTitle);

            const productCardId = this.getAttribute("product-card-id");
            const isCurrentCardProduct =
                productCardId === swatchProductDetails.node.id;

            if (isCurrentCardProduct) {
                this.classList.add("active");
            }

            // Swatch CSS encapsulated in shadow root
            const style = document.createElement('style');
            style.textContent = `
                .product-swatch {
                    cursor: pointer;
                    width: 25px;
                    height: 25px;
                    padding: 0;
                    background-color: transparent;
                    border: none;
                }
                .product-swatch__image {
                    width: 100%;
                    height: 100%;
                    background-position: center;
                    border-radius: 79px;
                    position: relative;
                    border: 1px solid lightgrey;
                    background-size: cover;
                }
                .product-swatch__image.pack_pd_swatch {
                    background-size: 25px;
                }
                .product-swatch__image:after {
                    content: "";
                    top: -3px;
                    left: -3px;
                    bottom: -3px;
                    right: -3px;
                    position: absolute;
                    border-radius: 79px;
                    border: 0.85px solid #27292c;
                    opacity: 0;
                    transition: opacity 0.25s;
                }
                .product-swatch__image:hover:after {
                    opacity: 1;
                }
                :host(.active) .product-swatch__image::after {
                    opacity: 1;
                }
                .hide-display, .d-none {
                    display: none !important;
                }
                @media (max-width: 768px) {
                    .product-swatch {
                        width: 21px;
                        height: 21px;
                    }
                }
            `;

            this.shadowRoot.appendChild(style);
            this.shadowRoot.appendChild(templateContent);

            // Bind events inside shadow DOM
            const swatchBtnTrigger = this.shadowRoot.querySelector(".product-swatch");
            swatchBtnTrigger.setAttribute("type", "button");

            // Use JS map to get details
            let siblingProductDetail = swatchSiblingProductDetailsMap.get(siblingProductId);
            if (siblingProductDetail.node.tags.includes('WSINGLES')) {
                swatchBtnTrigger.classList.add('swatch-single');
            }

            swatchBtnTrigger.addEventListener("click", () => {
                const siblingProductDetails = swatchSiblingProductDetailsMap.get(siblingProductId);
                let defaultSiblingFirst = siblingProductDetails.node.images.edges[0]?.node;

                if (siblingProductDetails?.node?.tags?.includes('PACK')) {
                    defaultSiblingFirst = siblingProductDetails.node.images.edges[0]?.node;
                }

                try {
                    if (defaultSiblingFirst?.url?.includes('vertical_')) {
                        for (const edge of siblingProductDetails?.node?.images?.edges || []) {
                            const url = edge.node.url;
                            if (url && !url?.includes('vertical_')) {
                                defaultSiblingFirst = edge.node;
                                break;
                            }
                        }
                    }
                } catch (e) {
                    defaultSiblingFirst = siblingProductDetails.node.images.edges[0]?.node;
                    console.log(e);
                }

                const firstImage = Utils.setImageUrlWidth(
                    defaultSiblingFirst?.url,
                    productCardImageWidth
                );

                // Find the product-card in the light DOM
                const productCard = this.closest("product-card");
                // Remove active class
                productCard.querySelectorAll('product-color-swatch')
                    .forEach(host => host.classList.remove('active'));
                this.classList.add('active');

                // Update selected ID
                productCard.setAttribute('data-selected-id', Utils.formatProductId(siblingProductDetails.node.id));
                productCard.setAttribute('data-product-id', Utils.formatProductId(siblingProductDetails.node.id));

                // Update images
                productCard
                    .querySelector(".product-card__first-image")
                    .setAttribute("src", firstImage);

                // Update product's URL
                productCard
                    .querySelectorAll(".product-card__url, .product-card__swatches-plus")
                    .forEach(
                        (productCardLink) =>
                            productCardLink.setAttribute('href', `/products/${siblingProductDetails.node.handle}`)
                    );

                //update quick add
                productCard.querySelector(".product-card__atc_btn.plp_quick_add")?.setAttribute('data-product-id', siblingProductDetails.node.id)

                // Update price
                Utils.renderCardPrice(
                    siblingProductDetails.node,
                    productCard.querySelector(".product-card__price"),
                    siblingProductDetails.node.priceRange.minVariantPrice.amount,
                    productCard
                );

                // Refresh reviews
                Utils.renderCustomStars(siblingProductDetails.node, productCard.querySelector(".okendo-star-rating"));

                productCard
                    .setAttribute(
                        "data-selected-id",
                        Utils.formatProductId(siblingProductDetails.node.id)
                    );

                let sibVarId = siblingProductDetails.node?.variants?.edges[0]?.node?.id?.replace('gid://shopify/ProductVariant/', '')?.trim();
                let sibProductId = siblingProductDetails.node?.id?.replace('gid://shopify/Product/', '')?.trim();
                let sibProductHandle = siblingProductDetails.node?.handle;

                try {
                    if (window.globalVariables?.settings?.wishlist_setting_enabled) {
                        let wishlistBtn = productCard.querySelector('[data-custom-wl-epi-btn] .swym-button');
                        if (wishlistBtn) {
                            wishlistBtn.setAttribute('data-product-id', sibProductId)
                            wishlistBtn.setAttribute('data-variant-id', sibVarId)
                            wishlistBtn.setAttribute('data-product-url', `https://woxer.com/products/${sibProductHandle}`)
                            wishlistBtn.classList.forEach(className => {
                                if (className.startsWith('product_')) {
                                    wishlistBtn.classList.remove(className);
                                }
                            });

                            wishlistBtn.classList.add(`product_${sibProductId}`);
                        }
                    }
                } catch (e) {
                    console.log(e)
                }

                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            });
        }
    }

    class ProductCard extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const templateInstance = document.getElementById("product-card-template");
            const templateContent = templateInstance.content.cloneNode(true);

            // Use JS maps instead of data attributes
            const productId = this.getAttribute("product-id");
            const productDetails = productDetailsMap.get(productId);
            const collectionData = collectionDataMap.get(productId);

            this.dataset.selectedId = Utils.formatProductId(productDetails.id);
            const title = productDetails.title;
            const colorValue = productDetails?.options.find(opt => opt.name === "Color")?.values[0]?.trim() || '';
            let woxerProgram = productDetails.woxerProgram?.value;
            woxerProgram = woxerProgram ? JSON.parse(woxerProgram) : null;

            const firstImage = {
                src: Utils.setImageUrlWidth(
                    this.getAttribute("first-image-src"),
                    productCardImageWidth
                ),
                alt: Utils.setImageUrlWidth(
                    this.getAttribute("first-image-alt"),
                    productCardImageWidth
                ),
            };

            let colorLessName = title.replace(colorValue, '')?.trim();
            let woxerProgramName = woxerProgram?.[0]?.toUpperCase()?.trim() || '';
            templateContent.querySelector(".product-card__title_woxerprogram").innerText = woxerProgramName;
            templateContent.querySelector(".product-card__title_colorless").innerText = colorLessName;

            const nameMap = {
                "Baller": "5” Boxer Brief",
                "Star": "3” Boxer Brief",
                "Biker": "9” Boxer Brief",
                "Baller High Waisted": "5” High Waisted",
                "Biker High Waisted": "9” High Waisted",
                "Baller Fly 5\"": "5” Boxer Brief w/ Fly",
                "Baller Flex": "5” Active Boxer Brief",
                "Baller Fly 7\"": "7” Boxer Brief w/ Fly",
                "Bold": "Boyshorts",
                "Classic": "Briefs",
                "Dreamer": "Boxer w/ Pockets",
                "Baller Pad Liner": "5” Boxer w/ Pad Liner",
                "Baller Luxe": "5” Luxe Boxer Brief",
                "Baller Rib": "5” Ribbed Boxer Brief",
                "Bold Luxe": "Luxe Boyshorts",
            };

            templateContent.querySelector(".product-card__title_colorless.ab-test").innerText = nameMap[colorLessName?.replace('3-Pack', '')?.replace('4-Pack', '')?.replace('5-Pack', '')?.replace('6-Pack', '')?.replace('7-Pack', '')?.replace('10-Pack', '')?.trim()] || colorLessName;

            const priceWrapper = templateContent.querySelector(
                ".product-card__price"
            );
            const priceValue = parseFloat(
                productDetails.priceRange.minVariantPrice.amount
            );

            //update quick add
            templateContent.querySelector(".product-card__atc_btn.plp_quick_add")?.setAttribute('data-product-id', Utils.formatProductId(productDetails.id))

            Utils.renderCardPrice(
                productDetails,
                priceWrapper,
                priceValue,
                templateContent
            );

            const productURL = this.getAttribute("product-url");

            const anchorElements =
                templateContent.querySelectorAll(".product-card__url");
            anchorElements.forEach((anchor) =>
                anchor.setAttribute("href", productURL)
            );

            const badgePackElement = templateContent.querySelector('.badge-pack');
            if (badgePackElement && productDetails.packThumbnailTagNumber) {
                badgePackElement.classList.remove('d-none');
                badgePackElement.innerText = productDetails.packThumbnailTagNumber.value + ' Pack'
            }

            const firstImageElement = templateContent.querySelector(
                ".product-card__first-image"
            );
            firstImageElement.setAttribute("src", firstImage.src);
            firstImageElement.setAttribute("alt", firstImage.alt);
            firstImageElement?.setAttribute(
                "data-link-subcategory",
                collectionData.collection.handle.replace("col1-", "").replaceAll("-", " ").toUpperCase()
            );
            firstImageElement?.setAttribute("data-link-text", title);

            const productCardMediaAction = templateContent.querySelector(
                ".product-card__media-action"
            );
            let productCardDataLinkSubCategory = collectionData.collection?.handle?.replace("col1-", "").replaceAll("-", " ").toUpperCase();
            productCardMediaAction?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            productCardMediaAction?.setAttribute("data-link-text", title);

            templateContent.querySelector(".product-card__title")?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            templateContent.querySelector(".product-card__title")?.setAttribute("data-link-text", title);

            templateContent.querySelector(".product-card__detail")?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            templateContent.querySelector(".product-card__detail")?.setAttribute("data-link-text", title);

            const okendoReviews = templateContent.querySelector(".okendo-star-rating");
            Utils.renderCustomStars(productDetails, okendoReviews);

            this.appendChild(templateContent);
            // Attach Product card's events
            attachProductCardsEvents(this);

            try {
                if (window.globalVariables?.settings?.wishlist_setting_enabled) {
                    const firstVariantId = productDetails?.variants?.edges[0]?.node?.id;
                    let wishlistBtn = this.querySelector('[data-custom-wl-epi-btn] .swym-button');
                    let coreProductId = productDetails?.id?.replace('gid://shopify/Product/', '')?.trim();
                    if (wishlistBtn) {
                        wishlistBtn.setAttribute('data-product-id', coreProductId)
                        wishlistBtn.setAttribute('data-variant-id', firstVariantId.replace('gid://shopify/ProductVariant/', '')?.trim())
                        wishlistBtn.setAttribute('data-product-url', `https://woxer.com/products/${productDetails.handle}`)
                        wishlistBtn.classList.forEach(className => {
                            if (className.startsWith('product_')) {
                                wishlistBtn.classList.remove(className);
                            }
                        });

                        wishlistBtn.classList.add(`product_${coreProductId}`);
                    }
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    class FilterOption extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("filter-option-template");
            const templateInstance = template.cloneNode(true);
            const templateContent = templateInstance.content;

            this.classList.add('close');

            const filterDetails = JSON.parse(this.getAttribute("filter-details"));
            let filterTitle;

            if (filterDetails.label === "Filter Color") {
                filterTitle = "Color";
            } else {
                filterTitle = filterDetails.label;
            }
            templateContent.querySelector(".filter-option__title").innerText =
                filterTitle;
            this.setAttribute('filter-label-value', filterTitle.toLowerCase())
            filterDetails.values.forEach((value) => {
                const filterValuesWrapper = templateContent.querySelector(
                    ".filter-option__values"
                );

                if (filterDetails.id.includes("color")) {
                    filterValuesWrapper.classList.add("filter-color-wrapper");
                } else {
                    filterValuesWrapper.classList.add(filterDetails.id.includes("size") ? "grid-filter" : "list-filter");
                }

                if (filterDetails.type === "LIST") {
                    const filterValueLabel = Utils.getListFilterSwatch(
                        filterDetails,
                        value
                    );

                    filterValuesWrapper.append(filterValueLabel);
                }
            });

            this.appendChild(templateContent);

            attachFiltersEvents(this, filterDetails);
        }
    }

    class FilterBubble extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("filter-bubble-filter");
            const templateInstance = template.cloneNode(true);
            const templateContent = templateInstance.content;

            const bubbleParam = this.getAttribute("data-param-name");
            const bubbleValue = this.getAttribute("data-label");
            const displayLabel = this.getAttribute("data-display-label") || bubbleValue;
            templateContent.querySelector(".filter-bubble-label").innerText =
                displayLabel;

            this.appendChild(templateContent);

            this.addEventListener("click", () => {
                Utils.removeQueryParam(bubbleParam, bubbleValue);
            });
        }
    }

    // Define web components
    customElements.define("product-card", ProductCard);
    customElements.define("filter-option", FilterOption);
    customElements.define("product-color-swatch", ProductColorSwatch);
    customElements.define("filter-bubble", FilterBubble);

    // GraphQL Queries

    const ALL_PRODUCTS_COLLECTION_QUERY = `query BundleCollections($buyer: BuyerInput) @inContext(buyer: $buyer) {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: {{product_count_main}} sortKey: {{sort_key}} reverse: {{reverse}} {{cursor_details}}) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
        edges {
        cursor
          node {
            id
            title
            handle
            tags
            publishedAt
            productType
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            options {
              name
              values
            }
            variants(first: 1) {
              edges {
                node {
                    id
                  sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
              value
            }
            woxerProgram: metafield(namespace: "custom", key: "woxer_program") {
                value
              }
            collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
              extraLabelColor: metafield(namespace: "custom", key: "special_label_text_color") {
                value
              }
              extraLabelBackground: metafield(namespace: "custom", key: "special_label_background_color") {
                value
              }
              totalInventory
              rating: metafield(namespace: "reviews", key: "rating") {
                value
              }
              ratingCount: metafield(namespace: "reviews", key: "rating_count") {
                value
              }
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
        filters {
          id
          label
          type
          values {
            count
            id
            label
            input
          }
        }
      }
    }
  }
`;
    const FILTER_PRODUCTS_QUERY = `query BundleCollections($buyer: BuyerInput) @inContext(buyer: $buyer) {
  collection(handle: "{{collection_handle}}") {
    handle
    products(first: {{product_count}} {{filters_details}} sortKey: {{sort_key}} reverse: {{reverse}} {{cursor_details}}) {
        pageInfo {
            hasNextPage
            hasPreviousPage
          }
        edges {
            cursor
        node {
          id
          title
          handle
          tags
          publishedAt
          productType
          packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
            value
          }
          woxerProgram: metafield(namespace: "custom", key: "woxer_program") {
            value
          }
          collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
            value
          }
          extraLabelColor: metafield(namespace: "custom", key: "special_label_text_color") {
            value
          }
          extraLabelBackground: metafield(namespace: "custom", key: "special_label_background_color") {
            value
          }
          totalInventory
          rating: metafield(namespace: "reviews", key: "rating") {
            value
          }
          ratingCount: metafield(namespace: "reviews", key: "rating_count") {
            value
          }
          okendoRating: metafield(namespace: "okendo", key: "rating") {
            value
          }
          okendoRatingCount: metafield(namespace: "okendo", key: "rating_count") {
            value
          }
          okendoSnippet: metafield(namespace: "okendo", key: "StarRatingSnippet") {
            value
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          options {
            name
            values
          }
          variants(first: 1) {
            edges {
              node {
              id
                sellingPlanAllocations(first: 10) {
                  edges {
                    node {
                      priceAdjustments {
                        price {
                          amount
                          currencyCode
                        }
                      }
                      sellingPlan {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
          images(first: 2) {
            edges {
              node {
                url
                altText
              }
            }
          }
        }
      }
      filters {
        id
        label
        type
        values {
          count
          id
          label
          input
        }
      }
    }
  }
}
`;

    const SINGLE_PRODUCT_BY_HANDLE_QUERY = `
  query SingleProductByHandle($handle: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
    product(handle: $handle) {
      id
      title
      handle
      tags
      publishedAt
      productType
      packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
        value
      }
      woxerProgram: metafield(namespace: "custom", key: "woxer_program") {
        value
      }
      collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
        value
      }
      extraLabelColor: metafield(namespace: "custom", key: "special_label_text_color") {
        value
      }
      extraLabelBackground: metafield(namespace: "custom", key: "special_label_background_color") {
        value
      }
      totalInventory
      rating: metafield(namespace: "reviews", key: "rating") {
        value
      }
      ratingCount: metafield(namespace: "reviews", key: "rating_count") {
        value
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
      }
      options {
        name
        values
      }
      variants(first: 1) {
        edges {
          node {
          id
            sellingPlanAllocations(first: 10) {
              edges {
                node {
                  priceAdjustments {
                    price {
                      amount
                      currencyCode
                    }
                  }
                  sellingPlan {
                    id
                  }
                }
              }
            }
          }
        }
      }
      images(first: 2) {
        edges {
          node {
            url
            altText
          }
        }
      }
    }
  }
`;

    const PRODUCT_SWATCHES_QUERY = `
  query ProductSwatch($buyer: BuyerInput) @inContext(buyer: $buyer) {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 100) {
        edges {
          node {
            id
            handle
            title
            tags
            publishedAt
           collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
            priceRange {
              minVariantPrice {
                amount
              }
            }
              collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
               extraLabelColor: metafield(namespace: "custom", key: "special_label_text_color") {
                value
              }
              extraLabelBackground: metafield(namespace: "custom", key: "special_label_background_color") {
                value
              }
               options {
                  name
                  values
                }
              totalInventory
              rating: metafield(namespace: "reviews", key: "rating") {
                value
              }
              ratingCount: metafield(namespace: "reviews", key: "rating_count") {
                value
              }
            variants(first: 1) {
              edges {
                node {
                id
                sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            packIcon: metafield(namespace: "custom", key: "pack_icon") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
            images(first: 1) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
  `;
    const PRODUCT_FILTER_SWATCHES_QUERY = `
  query ProductSwatch($buyer: BuyerInput) @inContext(buyer: $buyer) {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 100 {{filters_details}} sortKey: {{sort_key}} reverse: {{reverse}}) {
        edges {
          node {
            id
            title
            handle
            tags
            publishedAt
           collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
            priceRange {
              minVariantPrice {
                amount
              }
            }
              collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
            variants(first: 1) {
              edges {
                node {
                id
                sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            packIcon: metafield(namespace: "custom", key: "pack_icon") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
            images(first: 1) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
  `;

    // Swatch sibling product details storage
    const swatchSiblingProductDetailsMap = new Map();
    // Store sibling products details for each product card
    const siblingProductsDetailsMap = new Map();
    // Store product details and collection data for each product card
    const productDetailsMap = new Map();
    const collectionDataMap = new Map();

    // Swatch API cache
    const swatchApiCache = {};

    async function getSwatchDataCached(handle) {
        if (swatchApiCache[handle]) {
            return swatchApiCache[handle];
        }
        const query = getSwatchCollectionQuery().replaceAll("{{collection_handle}}", handle);
        const result = await useQuery(query);
        swatchApiCache[handle] = result;
        return result;
    }

    // Web components rendering functions
    const removeAllElements = (renderFilterOptions, loadMore) => {
        const productCards = document.querySelectorAll("product-card");
        const filterOptions = document.querySelectorAll("filter-option");

        if (!loadMore) {
            productCards.forEach((productCard) => productCard.remove());
        }
        if (renderFilterOptions) {
            filterOptions.forEach((filterOption) => filterOption.remove());
        }
    };

    const createFilterOptions = (filters) => {
        filters.forEach((filter) => {
            let hideFilters = document.querySelector('[data-hide-filters]').getAttribute('data-hide-filters')?.toLowerCase()?.split(',');
            let filter_label = filter.label.toLowerCase();
            if (!hideFilters.includes(filter_label)) {
                const filterOptions = Array.from(
                    document.getElementsByTagName("filter-option")
                );
                const matchedFilterOption = filterOptions.find(
                    (option) => option.getAttribute("filter-id") === filter.id
                );

                if (!matchedFilterOption) {
                    const filterOption = document.createElement("filter-option");
                    filterOption.setAttribute("filter-id", filter.id);
                    filterOption.setAttribute("filter-details", JSON.stringify(filter));
                    if (filter.id === 'filter.p.m.custom.styles') {
                        filterOption.classList.add('style_filter_option');
                    }
                    document
                        .querySelector(".collection-facets__filter-options")
                        .append(filterOption);
                } else {
                    if (filter.type === "LIST") {
                        filter.values.forEach((value) => {
                            const filterValuesWrapper = matchedFilterOption.querySelector(
                                ".filter-option__values"
                            );
                            const currentFilterValues = Array.from(
                                matchedFilterOption.querySelectorAll(
                                    ".filter-option__values label"
                                )
                            );
                            const isAlreadyInList = currentFilterValues.some(
                                (filterValue) => {
                                    return filterValue.dataset.value.toLowerCase() ===
                                        (filterValue.dataset.filterId === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value?.toLowerCase()) : value.label.toLowerCase());
                                }
                            );
                            if (!isAlreadyInList) {
                                const filterValueLabel = Utils.getListFilterSwatch(filter, value);
                                filterValuesWrapper.append(filterValueLabel);
                            }
                        });
                    }
                }
            }
        });

        sortFiltersBySettings();

        if (document.querySelector('[data-new-collection-structure]')) {
            let selectedFilters = document.querySelectorAll('.collection-facets-wrapper .active:not(.sort-by-filters .active)');
            if (selectedFilters.length <= 0) {
                let clearAllBtns = document.querySelectorAll('.filter-clear-all:not(.hide-display)');
                if (clearAllBtns.length) {
                    clearAllBtns[0]?.click();
                }
            }
        }
    };

    const sortFiltersBySettings = () => {
        try {
            let allFilterOptions = Array.from(
                document.getElementsByTagName("filter-option")
            );

            if (filterSortingSettings && filterSortingSettings.length) {
                allFilterOptions.forEach((filterElement) => {
                    const filterLabelValue = filterElement.getAttribute("filter-label-value").toLowerCase();
                    let orderIndex = filterSortingSettings.findIndex(setting => filterLabelValue.includes(setting.toLowerCase()));
                    filterElement.style.order = orderIndex !== -1 ? orderIndex + 1 : 20;

                    let subFilterProcessedArray = processSubFilterSorting(subFilterSortingSettings);
                    const matchedKey = Object.keys(subFilterProcessedArray).find(
                        key => filterLabelValue.includes(key.toLowerCase())
                    );
                    const sortingOrder = matchedKey ? subFilterProcessedArray[matchedKey] : null;

                    if (sortingOrder) {
                        let allLabels = Array.from(filterElement.querySelectorAll("label.filter-checkbox"));

                        allLabels.forEach((labelElement) => {
                            let labelValue = labelElement.getAttribute("data-value")?.toLowerCase();
                            if (labelValue && labelValue.includes('/shopify')) {
                                labelValue = labelElement.getAttribute("title")?.toLowerCase();
                            }
                            let orderIndex = sortingOrder.findIndex(setting => labelValue.includes(setting.toLowerCase()));

                            labelElement.style.order = orderIndex !== -1 ? orderIndex + 1 : 30;
                        });
                    }
                });
            }
        } catch (e) {
            console.log('error from filter sorting')
        }
    }

    const processSubFilterSorting = (sortingArray) => {
        let sortingObject = {};

        sortingArray.forEach(entry => {
            let [mainFilter, subFilter] = entry.split(":").map(str => str.trim());

            if (!sortingObject[mainFilter]) {
                sortingObject[mainFilter] = [];
            }
            sortingObject[mainFilter].push(subFilter);
        });

        return sortingObject;
    };

    const createProductsCards = (collectionData, products) => {
        let productCardIndex = 0;
        let oldProductCardMiniBannerGap = 0;
        let productCardMiniBannerStep = 1;
        let productsLength = products.length;
        let preparedProducts = [];

        products.forEach((product) => {
            if (product?.node?.tags?.includes(window.globalVariables.hidden_tag)) {
                productsLength--;
                return;
            }

            if (window.globalVariables.woxer_only === 'true') {
                if (product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag)) {
                    productsLength--;
                    return;
                }

                if (product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag_2)) {
                    productsLength--;
                    return;
                }
            }

            const productCard = document.createElement("product-card");
            // Save product information
            productCard.setAttribute(
                "product-url",
                `/products/${product.node.handle}`
            );

            let subscriptionOnlyTags = window.globalVariables.settings.subscription_only_tag.split(',');
            let subscriptionOnlyTagFound = false;
            subscriptionOnlyTags.forEach(subscriptionOnlyTag => {
                if (product?.node?.tags?.includes(subscriptionOnlyTag)) {
                    subscriptionOnlyTagFound = true;
                }
            })

            if (window.globalVariables.settings.enable_subscription_only && subscriptionOnlyTagFound) {
                productCard.classList.add('subscription-only')
            }

            let defaultFirst = product.node.images.edges[0]?.node;

            try {
                if (defaultFirst?.url?.includes('vertical_')) {
                    for (const edge of product?.node?.images?.edges || []) {
                        const url = edge.node.url;
                        if (url && !url?.includes('vertical_')) {
                            defaultFirst = edge.node;
                            break;
                        }
                    }
                }
                if (product?.node?.tags?.includes('PACK')) {
                    defaultFirst = product.node.images.edges[0]?.node;
                }
            } catch (e) {
                defaultFirst = product.node.images.edges[0]?.node;
                console.log(e);
            }

            productCard.setAttribute(
                "first-image-src",
                defaultFirst?.url
            );
            productCard.setAttribute(
                "product-is-pack",
                product?.node?.tags?.includes('PACK') ? 'true' : 'false'
            )
            productCard.setAttribute(
                "first-image-alt",
                defaultFirst?.altText || ""
            );

            productCard.setAttribute(
                "collection-style-group",
                product.node.collectionStyleGroup?.value || ""
            );

            productCard.setAttribute(
                "product-pack-size",
                product.node.packThumbnailTagNumber?.value || ""
            );

            productCard.setAttribute(
                "product-tags",
                product.node.tags?.join(",") || ""
            );

            productCard.setAttribute(
                "data-collection-product-card",
                ""
            )

            productCard.setAttribute('product-type', product.node.productType);
            productCard.setAttribute("product-id", product.node.id);
            productDetailsMap.set(product.node.id, product.node);
            collectionDataMap.set(product.node.id, collectionData);

            const matchedCollectionElement = collectionsElements.find(
                (element) => element.dataset.handle === collectionData.collection.handle
            );
            let isSpecialCollection = document.querySelector('[data-new-collection-structure]') || document.querySelector('[data-allow-infinte-scroll]');
            if (!isSpecialCollection) {
                productCard.style.order = productCardIndex.toString();
            }

            // matchedCollectionElement.append(productCard);
            if (!preparedProducts.hasOwnProperty(collectionData.collection.handle)) {
                preparedProducts[collectionData.collection.handle] = [];
            }
            preparedProducts[collectionData.collection.handle].push(productCard);
            productCardIndex++;

            const miniBannerGap = Utils.isMobile() ? 2 : 4;
            if (productCardIndex % (miniBannerGap * productCardMiniBannerStep) === 0) {
                let miniBannerEl = matchedCollectionElement.querySelector(`[data-collection-mini-banner-index="${productCardMiniBannerStep}"]`);
                if (miniBannerEl) {
                    if ((oldProductCardMiniBannerGap + productCardIndex - 1) >= productsLength) {
                        miniBannerEl.style.display = 'none';
                    } else {
                        miniBannerEl.style.display = 'block';
                    }
                    miniBannerEl.style.order = (oldProductCardMiniBannerGap + productCardIndex).toString();
                    oldProductCardMiniBannerGap = (miniBannerGap * productCardMiniBannerStep);
                    productCardMiniBannerStep++;
                }
            }
        });

        Object.keys(preparedProducts).forEach(collectionHandle => {
            const matchedCollectionElement = collectionsElements.find(
                (element) => element.dataset.handle === collectionHandle
            );
            if (matchedCollectionElement) {
                const fragment = document.createDocumentFragment();
                preparedProducts[collectionHandle].forEach(productCard => {
                    fragment.append(productCard);
                });
                removeSkeleton();
                matchedCollectionElement.appendChild(fragment);
            }
        });

        window.okeWidgetApi?.initAllWidgets();

        // Fallback: Hide skeletons after 10 seconds if widgets fail to load or initialize
        setTimeout(() => {
            document.querySelectorAll('.okendo-star-skeleton').forEach(skeleton => {
                if (skeleton.isConnected) {
                    skeleton.style.display = 'none';
                }
            });
        }, 5000);
        updateProductCardOrderAndMiniBanners('.collection-bundle');
    };

    const updateFilterQuery = (loadMore) => {

        if (!loadMore) {
            document.querySelector('.collection-product-wrapper')?.classList.add('d-none');
            document.querySelector('.collection-skeleton')?.classList.remove('d-none');
        }

        const filtersDetails = {
            filters: [],
        };
        const filterQueryParams = Object.entries(Utils.getAllQueryParams());

        if (filterQueryParams.length === 0) {
            return "";
        }

        let hasSizeFilter = false;
        filterQueryParams.forEach((filterQueryParam) => {
            const queryParamName = filterQueryParam[0];
            const queryParamValues = filterQueryParam[1].split(",");

            if (queryParamName.includes("filter.v.option.")) {
                const optionName = queryParamName.replaceAll("filter.v.option.", "");
                if (optionName.toLowerCase() === "size") {
                    hasSizeFilter = true;
                }
                queryParamValues.forEach((value) => {
                    filtersDetails.filters.push({
                        variantOption: {
                            name: optionName,
                            value: value,
                        },
                    });
                });
            } else if (queryParamName.includes("filter.p.m.")) {
                const metafieldDetails = queryParamName.replaceAll("filter.p.m.", "");
                const metafieldValues = queryParamValues;
                const metafieldDetailsList = metafieldDetails.split(".");
                const metafieldNamespace = metafieldDetailsList[0];
                const metafieldKey = metafieldDetailsList[1];

                metafieldValues.forEach((value) => {
                    filtersDetails.filters.push({
                        productMetafield: {
                            namespace: metafieldNamespace,
                            key: metafieldKey,
                            value: value,
                        },
                    });
                });
            } else if (queryParamName === 'filter.p.tag') {
                queryParamValues.forEach((value) => {
                    filtersDetails.filters.push({ tag: value });
                });
            }
        });

        if (filtersDetails.filters.length > 0) {
            filtersDetails.filters.push({ available: true })
        }

        return filtersDetails;
    };

    function togglePaginationLoading(isLoading) {
        const paginationWrapper = document.querySelector('.col-pagination-info');
        if (!paginationWrapper) return;
        paginationWrapper.classList.toggle('loading_new', !!isLoading);
    }

    const afterRender = (allCollectionsData, renderFilterOptions, loadMore = false) => {
        /* This function is used to render extra elements after the product collections and filters are rendered */
        let totalProducts = collectionsElements.reduce((acc, bundle) => {
            const productsCount = parseInt(
                bundle.getAttribute("data-products-count").length ? bundle.getAttribute("data-products-count") : '0'
            );
            return acc + productsCount;
        }, 0);

        const productsCountElements = document.querySelectorAll(".collections-bundles__product-count");
        const productCountDesktop = document.querySelector('.collection-bundle:not(.d-none) .category-pd-counts');
        const firstValidElement = document.querySelector('.collection-bundle[data-products-count]:not([data-products-count="0"])');
        if (firstValidElement) {
            firstValidElement.classList.add('mt-0');
            firstValidElement.querySelector('.ab_separator_new')?.classList?.add('mt-1');
        }
        if (document.querySelector('[data-new-collection-structure]')) {
            let wrapper = document.querySelector('.collection-product-wrapper .collection-bundle:not(.d-none)');
            let cardCount = wrapper?.querySelectorAll('product-card');
            if (cardCount) {
                totalProducts = cardCount.length;
            }

            if (document.querySelector('[data-new-collection-structure]')) {
                let totalProductCount = wrapper?.closest('[data-total-products-count]')?.getAttribute('data-total-products-count') || totalProducts;
                const hasFilterParam = Array.from(new URLSearchParams(window.location.search).keys()).some(key => key.startsWith("filter"));
                if (hasFilterParam) {
                    if (allCollectionsData[0].filters) {
                        currentFilters = allCollectionsData[0].filters;
                    }
                    totalProducts = estimateCountSmart()?.estimate || totalProducts;
                } else {
                    totalProducts = totalProductCount;
                }
            }
        }
        totalProducts = Math.min(Number(totalProducts) || 0, MAX_PRODUCTS_PER_COLLECTION);
        productsCountElements.forEach(ele => {
            ele.innerText = `${totalProducts} ${totalProducts > 1 ? "products" : "product"
                }`;
        })

        if (productCountDesktop) {
            productCountDesktop.innerText = `(${totalProducts})`;
        }

        const paginationLoadedEl = document.querySelector('[data-loaded-item-number]');
        const paginationTotalEl = document.querySelector('[data-total-item-number]');
        if (paginationLoadedEl && paginationTotalEl) {
            const activeBundle = document.querySelector('.collection-bundle:not(.d-none)');
            const loadedProducts = activeBundle ? activeBundle.querySelectorAll('product-card').length : 0;
            paginationLoadedEl.innerText = Math.min(loadedProducts, totalProducts);
            paginationTotalEl.innerText = totalProducts;
            const paginationWrapper = paginationLoadedEl.closest('.col-pagination-info');
            if (paginationWrapper) {
                if (loadedProducts > 0 && totalProducts > 0) {
                    paginationWrapper.classList.remove('hidden');
                    paginationWrapper.classList.remove('loading_new');
                } else {
                    paginationWrapper.classList.add('hidden');
                }
            }
        }

        // Sort by extra elements
        Utils.updateSortingElements();

        // refresh okendo reviews
        if (pageLoad == 1 && window.okeWidgetApi) {
            window.okeWidgetApi.initAllWidgets()
        }

        document.querySelector('.collection-product-wrapper')?.classList.remove('d-none');
        document.querySelector('.collection-product-wrapper').style.opacity = 1;
        document.querySelector('.collection-skeleton')?.classList.add('d-none');
        togglePaginationLoading(false);
        pageLoad = 0;
        applyingFilter = false;
        loadinSpecialCollection = false;
    };

    function estimateCountSmart(strategyByFacetId = {}) {
        if (!Array.isArray(currentFilters) || !currentFilters.length) {
            return { estimate: 0, facetCounts: {}, appliedFacets: [] };
        }

        const params = new URL(location.href).searchParams;

        const chooseStrategy = (facet) => {
            if (strategyByFacetId[facet.id]) return strategyByFacetId[facet.id];
            if (facet.id.startsWith('filter.v.option.')) return 'max';
            if (facet.type === 'PRICE_RANGE') return 'ignore';
            if (facet.id === 'filter.v.availability') return 'sum';
            return 'sum';
        };

        const facetCounts = {};
        const appliedFacets = [];
        const allFacetMins = [];

        for (const facet of currentFilters) {
            // Collect selections for this facet from URL; supports repeated params and comma lists
            const selections = params.getAll(facet.id);
            if (!selections.length) continue;

            const wanted = new Set(
                selections.flatMap(s => s.split(','))
                    .map(s => s.trim())
                    .filter(Boolean)
                    .map(s => s.toLowerCase())
            );
            if (!wanted.size) continue;

            if (!Array.isArray(facet.values) || facet.values.length === 0) continue;

            // Gather counts for selected labels that exist in this facet
            const selectedCounts = [];
            let selectedHasAllBucket = false;

            for (const v of facet.values) {
                if (!v || typeof v.label !== 'string') continue;
                const labelLc = v.label.toLowerCase();
                if (wanted.has(labelLc)) {
                    selectedCounts.push(Number(v.count) || 0);
                    if (/^all\s+/i.test(v.label)) selectedHasAllBucket = true;
                }
            }

            if (!selectedCounts.length) {
                // Selected values not present in facet → intersection is 0
                return { estimate: 0, facetCounts, appliedFacets };
            }

            let strategy = chooseStrategy(facet);
            if (strategy === 'sum' && selectedHasAllBucket) {
                // Safety: "All …" buckets overlap everything → avoid sum explosion
                strategy = 'max';
            }
            if (strategy === 'ignore') continue;

            const facetCount =
                strategy === 'max'
                    ? Math.max(...selectedCounts)
                    : selectedCounts.reduce((a, b) => a + b, 0);

            facetCounts[facet.label || facet.id] = facetCount;
            appliedFacets.push(facet.label || facet.id);
            allFacetMins.push(facetCount);
        }

        if (!allFacetMins.length) {
            return { estimate: 0, facetCounts, appliedFacets };
        }

        const estimate = Math.min(...allFacetMins);
        return { estimate, facetCounts, appliedFacets };
    }

    const showSpecificCollectionOnly = () => {
        let newValue = document.querySelector('[data-default-col-card]')?.getAttribute('data-default-col-card');
        setCardsForNewStructure(newValue);
        document.querySelectorAll('.collection-facets__filter-options .sort-by-filters')
            .forEach(ele => ele.classList.add('close'))
    }

    const setCardsForNewStructure = (newValue) => {
        let element = document.querySelector(`[data-plp-new-structure-card="${newValue}"]`)
        document.querySelectorAll('[data-plp-new-structure-products]').forEach(ele => ele.classList.add('d-none'));
        document.querySelector(`[data-plp-new-structure-products="${newValue}"]`)?.classList?.remove('d-none');
        // const url = new URL(window.location.href);
        // url.searchParams.set("sp_collection", newValue);
        // history.replaceState(null, null, url.toString());

        if (document.querySelector('[data-final-breadcrumb]')) {
            let breadTitle = element?.getAttribute('data-card-title')?.replace('All Underwear', '')?.replace('Shop All Bralettes & Tops', '')?.replace('Shop All Tops', '');
            if (breadTitle) {
                document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.remove('d-none'));
            } else {
                document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle || '');
                document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.add('d-none'));
            }
        }
        // adjustBreadcrumbs();
    }

    const scrollToElement = () => {
        const target = window.location.href.includes('scrollto') ? Utils.getQueryParam('scrollto=') : false;
        if (target) {
            const element = document.querySelector(`#${target}`);
            if (element) {
                if (!Utility.in_Viewport(element)) {
                    setTimeout(() => {
                        document.querySelector(`[href="#${target}"]`).click();
                    }, 2500);
                }
            }
        } else if (pageLoad === 0 && !pageCursor) {
            if (document.querySelector('[data-new-collection-structure]')) {
                if (!document.querySelector('.is-stuck-topcard')) {
                    window.scrollTo({
                        top: document.querySelector('[data-new-collection-structure]').offsetTop - 80,
                        left: 0
                    });
                } else {
                    window.scrollTo({
                        top: 80,
                        left: 0
                    });
                }
            } else if (document.querySelector('.plp_new_structure')) {
                document.documentElement.style.scrollBehavior = 'auto';
                window.scrollTo(0, 685);
            } else {
                document.documentElement.style.scrollBehavior = 'auto';
                const element = document.querySelector('.collections-bundles-top');
                if (!Utility.in_Viewport(element)) {
                    window.scrollTo({
                        top: element.offsetTop - 80,
                        left: 0
                    });
                }
                setTimeout(() => {
                    document.documentElement.style.scrollBehavior = 'smooth';
                }, 2000);
            }
        }
    }

    const filterVisibleProductEdges = (edges = []) => {
        return edges.filter((product) => {
            if (product?.node?.tags?.includes(window.globalVariables.hidden_tag)) {
                return false;
            }
            if (window.globalVariables.woxer_only === 'true') {
                if (product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag)) {
                    return false;
                }
                if (product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag_2)) {
                    return false;
                }
            }
            return true;
        });
    };

    const _getCARate = async (productId, localeCode = 'US') => {
        if (!productId) return;
        let id = `gid://shopify/Product/${productId}`;

        let query = ` query GetProductById($id: ID!) {
            product(id: $id) {
                priceRangeV2 {
                  maxVariantPrice {
                    amount
                  }
                }
                contextualPricing(context: {country: ${localeCode}}) {
                    maxVariantPricing {
                        price {
                            amount
                        }
                    }
                }
            }
        }`;

        let url = '/community/api/graphql';

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: { id: id }
            })
        };

        try {
            let response = await fetch(url, requestOptions);
            if (response.ok) {
                let data = await response.json();
                let actualPrice = data?.data?.product?.priceRangeV2?.maxVariantPrice?.amount || 0;
                let canPrice = data?.data?.product?.contextualPricing?.maxVariantPricing?.price?.amount || 0;

                if (actualPrice && canPrice) {
                    canadaRate = parseFloat(canPrice) / parseFloat(actualPrice);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }


    const renderCollection = async (query, renderFilterOptions = true, onLoad = false, loadMore = false) => {
        const requestId = ++renderRequestId;
        if (loadMore) {
            togglePaginationLoading(true);
        }
        scrollToElement();
        if (onLoad && renderFilterOptions && document.querySelector('[data-new-collection-structure]')) {
            showSpecificCollectionOnly();
        }

        removeAllElements(renderFilterOptions, loadMore);
        let isMiniBannerAvailable = document.querySelector('.collection-mini-banner');

        if (loadMore) {
            showSkeletonCards(16);
        }

        if (!renderFilterOptions) {
            syncFilterStatus();
        }

        // Build filter bubbles
        Utils.resetFilterBubbles();
        const allQueryParams = Object.entries(Utils.getAllQueryParams());
        const filterBubblesWrappers = document.querySelectorAll(
            ".collection-facets__filter-bubbles"
        );
        let appliedFilters = 0;
        const MainCardSliders = document.querySelectorAll('ul.collection-menu__items');
        const jumpLinkSliders = document.querySelectorAll('.collection-sticky-menu ul');

        allQueryParams.forEach((queryParam) => {
            const queryParamName = queryParam[0];
            const queryParamValues = queryParam[1].split(",");
            const isRelevantParam =
                queryParamName.includes("filter.") &&
                !queryParamName.includes("filter.v.price");
            if (queryParam && isRelevantParam) {
                queryParamValues.forEach((queryParamValue) => {
                    filterBubblesWrappers.forEach((filterBubbleWrapper) => {
                        appliedFilters = appliedFilters + 1;
                        const bubbleElement = document.createElement("filter-bubble");
                        bubbleElement.dataset.label = queryParamValue;
                        bubbleElement.dataset.paramName = queryParamName;
                        if (queryParamName === 'filter.p.tag') {
                            const saleLabelMap = { 'MD40-2026': '40% off', 'MD20-2026': '20% off' };
                            if (saleLabelMap[queryParamValue]) {
                                bubbleElement.dataset.displayLabel = saleLabelMap[queryParamValue];
                            }
                        }
                        filterBubbleWrapper.append(bubbleElement);
                    });
                });
            }
        });

        appliedFilters = appliedFilters / 2;

        // Hide/Show clear all buttons
        const filterQueryParams = Object.entries(Utils.getAllQueryParams()).filter(
            (param) => param[0].includes("filter.")
        );
        if (filterQueryParams.length > 0) {
            clearAllButtons.forEach((clearAllButton) =>
                clearAllButton.classList.remove("hide-display")
            );
            document.querySelectorAll('.filter-mobile-toggle .applied-filters').forEach(ele => ele.innerText = '(' + appliedFilters + ')')
        } else {
            clearAllButtons.forEach((clearAllButton) =>
                clearAllButton.classList.add("hide-display")
            );
            document.querySelectorAll('.filter-mobile-toggle .applied-filters').forEach(ele => ele.innerText = '')
        }

        const sortByValue = Utils.getQueryParam('sort_by');
        const sortByLabel = document.querySelector('.collections-bundles__sort-by-trigger span');
        if (sortByValue) {
            const newSortByLabel = Array.from(document.querySelectorAll('.sort-by-list button')).find(button => button.dataset.value === sortByValue);
            sortByLabel.innerText = `Sort by ${newSortByLabel.innerText.toLowerCase().replaceAll('radio button', '')}`;
        } else {
            sortByLabel.innerText = 'Sort By Featured';
        }
        let handles = [];

        let allCollElements = Array.from(
            document.querySelectorAll(".collection-bundle:not(.d-none)")
        );

        // if (window.location.pathname.includes("/collections/gift-shop")) {
        //     giftGuidePage = true;
        //     document.querySelector('[data-plp-new-structure-card]')?.click();
        //     return;
        // }
        if ((onLoad || giftGuidePage) && !loadMore && document.querySelector('[data-col-first-product]')) {
            giftGuidePage = false;
            let randomPdId = document.querySelector('[data-col-first-product]')?.getAttribute('data-col-first-product');
            let localeCode = document.querySelector('[data-localization-code]')?.getAttribute('data-localization-code') || 'US';
            if (randomPdId && localeCode !== 'US') {
                await _getCARate(randomPdId, localeCode);
            }
        }

        if (requestId !== renderRequestId) return;

        const allCollectionsData = await Promise.all(
            allCollElements.map(async (collection) => {
                const collectionHandle = collection.dataset.handle;
                let replacedQuery = query.replaceAll(
                    "{{collection_handle}}",
                    collectionHandle
                );
                const collectionData = collectionHandle && await useQuery(replacedQuery);

                if (!collectionData?.data?.collection) {
                    return {
                        edges: [],
                        filters: []
                    };
                }

                let productsLimit;
                const isMobile = Utils.isMobile();
                const isFiltered = window.location.href.includes('filter');
                const isClearanceCollection = collectionHandle && collectionHandle.includes('clearance-2024');

                if (isMobile) {
                    productsLimit = isFiltered
                        ? (isClearanceCollection ? parseInt(collection.dataset.productsLimitMobile) : 40)
                        : parseInt(collection.dataset.productsLimitMobile);
                } else {
                    productsLimit = isFiltered
                        ? (isClearanceCollection ? parseInt(collection.dataset.productsLimitDesktop) : 40)
                        : parseInt(collection.dataset.productsLimitDesktop);
                }

                const currentRenderedCount = loadMore
                    ? collection.querySelectorAll("product-card").length
                    : 0;
                const remainingSlots = MAX_PRODUCTS_PER_COLLECTION - currentRenderedCount;
                const cappedLimit = Math.max(
                    0,
                    Math.min(parseInt(productsLimit), remainingSlots)
                );

                let featuredProductsEdges = [];
                let colorFeaturedParam = Utils.getQueryParam('color.featured') || Utils.getQueryParam('featured');
                let productFeaturedParam = Utils.getQueryParam('product.featured');

                if (!loadMore && (colorFeaturedParam || productFeaturedParam)) {
                    let featuredIds = [];

                    // Case 1: Product specific pinning
                    if (productFeaturedParam) {
                        const productData = await useQuery(SINGLE_PRODUCT_BY_HANDLE_QUERY, { handle: productFeaturedParam });
                        const productNode = productData?.data?.product;
                        if (productNode) {
                            featuredProductsEdges.push({ node: productNode, cursor: "" });
                            featuredIds.push(productNode.id);
                        }
                    }

                    // Case 2: Color group pinning
                    if (colorFeaturedParam) {
                        let featuredColorTitle = colorFeaturedParam.replace(/-/g, ' ').split(' ').map(Utils.capitalizeStr).join(' ');
                        const featFiltersDetails = { filters: [{ productMetafield: { namespace: "custom", key: "colors", value: featuredColorTitle } }, { available: true }] };
                        const featFiltersString = Utils.formatFilterQuery(JSON.stringify(featFiltersDetails));
                        const featQuery = FILTER_PRODUCTS_QUERY
                            .replaceAll("{{filters_details}}", featFiltersString)
                            .replaceAll("{{sort_key}}", "COLLECTION_DEFAULT")
                            .replaceAll("{{product_count}}", "150")
                            .replaceAll("{{cursor_details}}", "")
                            .replaceAll("{{collection_handle}}", collectionHandle)
                            .replaceAll(" reverse: {{reverse}}", '');


                        const featData = await useQuery(featQuery);
                        const seatEdges = featData?.data?.collection?.products?.edges || [];
                        const filteredFeat = filterVisibleProductEdges(seatEdges);

                        filteredFeat.forEach(edge => {
                            if (!featuredIds.includes(edge.node.id)) {
                                featuredProductsEdges.push(edge);
                                featuredIds.push(edge.node.id);
                            }
                        });
                    }

                    window.featuredProductIds = featuredIds;
                } else if (!loadMore) {
                    window.featuredProductIds = [];
                }


                const filteredEdges = filterVisibleProductEdges(collectionData.data.collection.products.edges);
                let normalEdges = filteredEdges;
                if (window.featuredProductIds && window.featuredProductIds.length > 0) {
                    normalEdges = filteredEdges.filter(edge => !window.featuredProductIds.includes(edge.node.id));
                }

                let products = normalEdges.slice(0, cappedLimit);
                if (featuredProductsEdges && featuredProductsEdges.length > 0) {
                    products = [...featuredProductsEdges, ...products];
                }

                let hasNextPage = collectionData.data.collection?.products?.pageInfo?.hasNextPage;
                let lastCursor = collectionData.data.collection.products.edges.slice(-1)?.[0]?.cursor || '';

                // If first load returns fewer than the desired batch, pull one extra page (max 12) and append.
                const isWoxerOnlyEnabled = window.globalVariables.woxer_only === 'true';
                if ((isWoxerOnlyEnabled || (window.featuredProductIds && window.featuredProductIds.length > 0)) && products.length < cappedLimit && hasNextPage && !isMiniBannerAvailable) {
                    pageCursor = lastCursor || pageCursor;
                    const nextQuery = getCollectionQuery(true);
                    const nextReplacedQuery = nextQuery.replaceAll(
                        "{{collection_handle}}",
                        collectionHandle
                    );
                    const nextPageData = await useQuery(nextReplacedQuery);
                    const nextEdges = nextPageData?.data?.collection?.products?.edges || [];
                    const nextFiltered = filterVisibleProductEdges(nextEdges);

                    let normalNextEdges = nextFiltered;
                    if (window.featuredProductIds && window.featuredProductIds.length > 0) {
                        normalNextEdges = nextFiltered.filter(edge => !window.featuredProductIds.includes(edge.node.id));
                    }

                    const neededSlots = cappedLimit - products.length;
                    const nextSlice = normalNextEdges.slice(0, neededSlots > 0 ? neededSlots : 12);
                    products = products.concat(nextSlice);

                    if (nextSlice.length < normalNextEdges.length) {
                        hasNextPage = true;
                    } else {
                        hasNextPage = nextPageData?.data?.collection?.products?.pageInfo?.hasNextPage;
                    }
                    lastCursor = nextSlice[nextSlice.length - 1]?.cursor || lastCursor;
                }

                if (document.querySelector('.plp_new_structure') || document.querySelector('[data-allow-infinte-scroll]')) {
                    isNextPage = hasNextPage && (currentRenderedCount + products.length < MAX_PRODUCTS_PER_COLLECTION);
                    pageCursor = isNextPage && products.length ? (products[products.length - 1]?.cursor || lastCursor || '') : '';
                }

                collection.dataset.productsCount = Math.min(
                    currentRenderedCount + products.length,
                    MAX_PRODUCTS_PER_COLLECTION
                );

                const collectionMenuHandle = collection.getAttribute('id');
                let collectionMenuElement = document.querySelector('.collection-menu__item a[href="#' + collectionMenuHandle + '"]')
                let collectionMenuElementV2 = document.querySelector('.collection-menu__item.collection-menu__item_v2 a[href="#' + collectionMenuHandle + '"]')
                let collectionStickyMenuElement = document.querySelector('.collection-menu__item-sticky a[href="#' + collectionMenuHandle + '"]')
                if (collectionMenuElement && collectionMenuElementV2 && !document.querySelector('[data-new-collection-structure]')) {
                    if (products.length === 0 && !window.location.href.includes('clearance-2024')) {
                        collectionMenuElement.parentElement.classList.add('d-none')
                        collectionStickyMenuElement.parentElement.classList.add('d-none')
                        collectionMenuElementV2.parentElement.classList.add('d-none')
                    } else {
                        collectionMenuElement.parentElement.classList.remove('d-none')
                        collectionStickyMenuElement.parentElement.classList.remove('d-none')
                        collectionMenuElementV2.parentElement.classList.remove('d-none')
                    }
                }

                let packFilters = document.querySelectorAll('.filter-option__values label[data-value="4 Pack"]:not(.disabled), ' +
                    '.filter-option__values label[data-value="6 Pack"]:not(.disabled), ' +
                    '.filter-option__values label[data-value="10 Pack"]:not(.disabled)');
                if (packFilters.length > 0) {
                    document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => ele.classList.remove('d-none'));
                } else {
                    document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => ele.classList.add('d-none'));
                }

                createProductsCards(collectionData.data, products);
                const productCards = collection.querySelectorAll("product-card");
                productCards.forEach((productCard) => {
                    const productType = productCard.getAttribute('product-type');
                    let swatchCollectionHandle = Utils.handleize(productType)
                        .replace('baller-high-waisted', 'baller-highwaisted')
                        .replace('biker-high-waisted', 'biker-highwaisted')
                        .replace('baller-padliner', 'baller-pad-liner')
                        .replace('sleep-ss-shirt', 'sleep-short-sleeve-tee')
                        .replace('sleep-ls-shirt', 'sleep-long-sleeve-tee')
                        .replace('starhighwaisted-pack', 'star-high-waisted-pack')
                        .replace('ballerhighwaisted-pack', 'baller-high-waisted-pack')
                        .replace('bikerhighwaisted-pack', 'biker-high-waisted-pack')
                        .replace('tanktoprib-pack', 'tank-top-rib-pack')
                        .replace('ballerrib-pack', 'baller-rib-pack')
                        .replace('ballerflex-pack', 'baller-flex-pack')
                        .replace('bikerflex-pack', 'biker-flex-pack')
                        .replace('bossflex-pack', 'boss-flex-pack')
                        .replace('starflex-pack', 'star-flex-pack')
                        .replace('braletteluxe_pack', 'bralette-luxe-pack')
                        .replace('ballerluxe_pack', 'baller-luxe-pack')
                        .replace('braletteluxe-pack', 'bralette-luxe-pack')
                        .replace('ballerluxe-pack', 'baller-luxe-pack')
                        .replace('boldluxe_pack', 'bold-luxe-pack')
                        .replace('boldluxe-pack', 'bold-luxe-pack')
                        .replace('ballerpadliner-pack', 'baller-pad-liner-pack')
                        .replace('ballerswim-pack', 'baller-swim-pack')
                        .replace('bikiniswim-pack', 'bikini-swim-pack')
                        .replace('ballerfluidlight_pack', 'baller-fluid-light-pack')
                        .replace('ballerfluidlight-pack', 'baller-fluid-light-pack')
                        .replace('starfluidlight_pack', 'star-fluid-light-pack')
                        .replace('starfluidlight-pack', 'star-fluid-light-pack')
                        .replace('win_', 'win-')
                        .replace('_bra', '')
                        .replace('-bra', '')
                        .replace('_tee', '-tee')
                        .replace('bossswim-pack', 'boss-swim-pack');

                    if (swatchCollectionHandle === 'baller-tee') {
                        swatchCollectionHandle = 'win-baller-tee';
                    }

                    handles.push(swatchCollectionHandle)
                });
                if (renderFilterOptions && collectionData && typeof collectionData !== 'undefined') {
                    createFilterOptions(collectionData.data.collection.products.filters);
                }
                return typeof collectionData !== 'undefined' ? collectionData?.data.collection.products : [];
            })
        );

        if (requestId !== renderRequestId) return;

        loadingMore = false;
        let stickyElements = document.querySelectorAll('.collection-menu__item-sticky:not(.d-none)');
        if (stickyElements.length <= 3) {
            stickyElements[0]?.closest('ul')?.classList?.add('justify-content-center');
        } else {
            stickyElements[0]?.closest('ul')?.classList?.remove('justify-content-center');
        }
        for (let jumpLinkSlider of jumpLinkSliders) {
            if (jumpLinkSlider.scrollWidth > jumpLinkSlider.clientWidth) {
                jumpLinkSlider.classList.remove('justify-content-center');
                jumpLinkSlider.classList.add('justify-content-start');
            } else {
                jumpLinkSlider.classList.remove('justify-content-start');
                jumpLinkSlider.classList.add('justify-content-center');
            }
        }

        //for wishlist icon click
        document.querySelectorAll('[data-custom-wl-epi-btn]').forEach(ele => {
            ele.classList.remove('d-none');
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            })
        })

        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        MainCardSliders.forEach(el => el.classList.remove('opacity-0'));
        jumpLinkSliders.forEach(el => el.classList.remove('opacity-0'));

        Utils.updateFilterOptions();

        document.querySelectorAll('[data-filter-id]').forEach((ele) => {
            ele.classList.add('disabled');
        });

        allCollectionsData.forEach((collData) => {
            collData.filters.forEach((filter) => {
                let id = filter.id;
                filter.values.forEach((val) => {
                    if (val.count > 0) {
                        document.querySelector(`[data-filter-id='${id}'][data-value='${id === 'filter.p.m.custom.fabric_type' ? (JSON.parse(val.input))?.productMetafield?.value : val.label}']`)?.classList.remove('disabled');
                    }
                })
            })
        })

        if (requestId !== renderRequestId) return;

        afterRender(allCollectionsData, renderFilterOptions);
        handles = [...new Set(handles)];
        let swatchesData = {};

        await Promise.all(
            handles.map(async (handle) => {
                swatchesData[handle] = await getSwatchDataCached(handle);
            })
        )

        if (requestId !== renderRequestId) return;

        const allSwatchesData = await Promise.all(
            collectionsElements.map(async (collection) => {
                const productCards = collection.querySelectorAll("product-card");
                await Promise.all(Array.from(productCards).map(async (productCard) => {
                    const productId = productCard.getAttribute("product-id");
                    const productURL = productCard.getAttribute("product-url");
                    const productType = productCard.getAttribute('product-type');
                    const productTags = productCard.getAttribute('product-tags');
                    let productPackSize = productCard.getAttribute('product-pack-size');
                    let collectionStyleGroup = productCard.getAttribute('collection-style-group');
                    productPackSize = productPackSize.length !== 0 ? productPackSize : false;

                    // Build swatch collection handle
                    let swatchCollectionHandle = productType === 'mix_pack'
                        ? 'mixpack'
                        : Utils.handleize(productType)
                            .replace('baller-high-waisted', 'baller-highwaisted')
                            .replace('biker-high-waisted', 'biker-highwaisted')
                            .replace('baller-padliner', 'baller-pad-liner')
                            .replace('sleep-ss-shirt', 'sleep-short-sleeve-tee')
                            .replace('sleep-ls-shirt', 'sleep-long-sleeve-tee')
                            .replace('starhighwaisted-pack', 'star-high-waisted-pack')
                            .replace('ballerhighwaisted-pack', 'baller-high-waisted-pack')
                            .replace('bikerhighwaisted-pack', 'biker-high-waisted-pack')
                            .replace('tanktoprib-pack', 'tank-top-rib-pack')
                            .replace('ballerrib-pack', 'baller-rib-pack')
                            .replace('ballerflex-pack', 'baller-flex-pack')
                            .replace('bikerflex-pack', 'biker-flex-pack')
                            .replace('bossflex-pack', 'boss-flex-pack')
                            .replace('starflex-pack', 'star-flex-pack')
                            .replace('braletteluxe_pack', 'bralette-luxe-pack')
                            .replace('braletteluxe-pack', 'bralette-luxe-pack')
                            .replace('ballerluxe_pack', 'baller-luxe-pack')
                            .replace('ballerluxe-pack', 'baller-luxe-pack')
                            .replace('boldluxe_pack', 'bold-luxe-pack')
                            .replace('boldluxe-pack', 'bold-luxe-pack')
                            .replace('ballerpadliner-pack', 'baller-pad-liner-pack')
                            .replace('ballerswim-pack', 'baller-swim-pack')
                            .replace('bikiniswim-pack', 'bikini-swim-pack')
                            .replace('ballerfluidlight_pack', 'baller-fluid-light-pack')
                            .replace('ballerfluidlight-pack', 'baller-fluid-light-pack')
                            .replace('starfluidlight_pack', 'star-fluid-light-pack')
                            .replace('starfluidlight-pack', 'star-fluid-light-pack')
                            .replace('win_', 'win-')
                            .replace('_bra', '')
                            .replace('-bra', '')
                            .replace('_tee', '-tee')
                            .replace('bossswim-pack', 'boss-swim-pack');

                    if (swatchCollectionHandle === 'baller-tee') {
                        swatchCollectionHandle = 'win-baller-tee';
                    }
                    if (productURL.includes('vip') && swatchCollectionHandle !== 'mixpack') {
                        swatchCollectionHandle = `${swatchCollectionHandle}-vip`;
                    }

                    let settings = window.globalVariables.settings;
                    if (settings.enable_coming_soon && settings.coming_soon_product_tag.length > 0 && productTags.includes(settings.coming_soon_product_tag)) {
                        swatchCollectionHandle = `${swatchCollectionHandle}-coming-soon`;
                    }
                    if (settings.enable_new_release && settings.new_release_singles_product_tag.length && productTags.includes(settings.new_release_singles_product_tag)) {
                        swatchCollectionHandle = `${swatchCollectionHandle}-clearance`;
                        swatchCollectionHandle = swatchCollectionHandle.replace('ballerfly', 'baller-fly-');
                    }

                    // Fetch sibling products data
                    let siblingProductsData;
                    if (preparedSwatchData.hasOwnProperty(swatchCollectionHandle)) {
                        siblingProductsData = preparedSwatchData[swatchCollectionHandle];
                    } else {
                        siblingProductsData = await useQuery(PRODUCT_SWATCHES_QUERY.replaceAll("{{collection_handle}}", swatchCollectionHandle));
                        preparedSwatchData[swatchCollectionHandle] = siblingProductsData;
                    }

                    if (siblingProductsData.data.collection) {
                        let siblingProducts = siblingProductsData.data.collection?.products.edges;

                        // Filter logic
                        if (!swatchCollectionHandle.includes('mixpack')) {
                            siblingProducts = siblingProducts.filter(siblingProduct => {
                                return productPackSize && siblingProduct.node.tags.includes('PACK')
                                    ? siblingProduct.node.tags.includes(productPackSize + 'PACK')
                                    : siblingProduct;
                            });
                        }
                        siblingProducts = siblingProducts.filter(siblingProduct => {
                            return swatchCollectionHandle.includes('pack') === false
                                ? siblingProduct.node.tags.includes('WSINGLES')
                                : siblingProduct;
                        });
                        siblingProducts = siblingProducts.filter(siblingProduct => {
                            return swatchCollectionHandle.includes('mixpack')
                                ? siblingProduct.node.collectionStyleGroup.value === collectionStyleGroup
                                : siblingProduct;
                        });
                        if (settings.enable_new_release && settings.new_release_packs_product_tag) {
                            siblingProducts = siblingProducts.filter(siblingProduct => {
                                return productTags.includes(settings.new_release_packs_product_tag)
                                    ? siblingProduct.node.tags.includes(settings.new_release_packs_product_tag)
                                    : !siblingProduct.node.tags.includes(settings.new_release_packs_product_tag);
                            });
                        }
                        if (settings.enable_new_release && settings.new_release_singles_product_tag) {
                            siblingProducts = siblingProducts.filter(siblingProduct => {
                                return productTags.includes(settings.new_release_singles_product_tag)
                                    ? siblingProduct.node.tags.includes(settings.new_release_singles_product_tag)
                                    : !siblingProduct.node.tags.includes(settings.new_release_singles_product_tag);
                            });
                        }

                        // Move current product to front, then black products to end
                        siblingProducts.sort((a, b) => {
                            if (a.node.id === productId) return -1;
                            if (b.node.id === productId) return 1;
                            return 0;
                        });
                        let tempFilteredProducts = siblingProducts.filter(product => !product?.node?.tags?.includes(window.globalVariables.hidden_tag));
                        if (window.globalVariables.woxer_only === 'true') {
                            tempFilteredProducts = siblingProducts.filter(product => !(
                                product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag)
                                || product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag_2)
                            ));
                        }
                        let blackFound = false;
                        let blackProducts = [];
                        let filteredProducts = tempFilteredProducts.filter(product => {
                            if (product.node.title.toLowerCase().includes('black')) {
                                if (!blackFound) {
                                    blackFound = true;
                                    return true;
                                } else {
                                    blackProducts.push(product);
                                    return false;
                                }
                            }
                            return true;
                        });
                        filteredProducts = filteredProducts.concat(blackProducts);
                        siblingProducts = filteredProducts;

                        // Only render visible swatches (5 mobile, 6 desktop)
                        const visibleSwatchCount = Utils.isMobile() ? 5 : 6;
                        const slicedSiblingProducts = siblingProducts.slice(0, visibleSwatchCount);

                        const fragment = document.createDocumentFragment();
                        const colorSwatchesWrapper = productCard.querySelector(
                            ".product-card__swatches"
                        );
                        if (colorSwatchesWrapper) colorSwatchesWrapper.innerHTML = "";

                        slicedSiblingProducts.forEach((siblingProduct) => {
                            let swatchImage = siblingProduct.node.packIcon
                                ? siblingProduct.node.packIcon.reference.image.url
                                : siblingProduct.node.featuredImage
                                    ? siblingProduct.node.featuredImage.url
                                    : '';

                            const colorSwatch = document.createElement("product-color-swatch");
                            swatchSiblingProductDetailsMap.set(siblingProduct.node.id, siblingProduct);
                            colorSwatch.setAttribute('sibling-product-id', siblingProduct.node.id);
                            colorSwatch.setAttribute('swatch-image', swatchImage);
                            colorSwatch.setAttribute("product-card-id", productId);

                            fragment.append(colorSwatch);
                        });

                        // "+N" button for remaining swatches, lazy-load on click
                        if (siblingProducts.length > visibleSwatchCount) {
                            const plusSwatchesElement = document.createElement("a");
                            plusSwatchesElement.href = `${productURL}`;
                            plusSwatchesElement.classList.add("product-card__swatches-plus");
                            plusSwatchesElement.innerText = `+${siblingProducts.length - visibleSwatchCount}`;
                            fragment.append(plusSwatchesElement);
                        }

                        colorSwatchesWrapper.appendChild(fragment);

                        // Store all sibling products in JS Map for this product card
                        siblingProductsDetailsMap.set(productId, siblingProducts);
                    }
                }));
                return typeof collectionData !== 'undefined' ? collectionData?.data.collection.products : [];
            })
        );

        if (requestId !== renderRequestId) return;

        afterRender(allSwatchesData, renderFilterOptions, loadMore);
    };

    const syncFilterStatus = () => {
        const currentQueryParams = Object.entries(Utils.getAllQueryParams());
        console.log(currentQueryParams)
        const filterSwatches = document.querySelectorAll('.filter-swatch,.filter-checkbox');
        filterSwatches.forEach(filterSwatch => {
            if (!filterSwatch.dataset.filterId) return; // skip non-native filter controls
            const isActiveSwatch = currentQueryParams.some(queryParam => {
                const queryParamName = queryParam[0];
                const queryParamValue = queryParam[1];
                const currentParamValueArr = queryParamValue.split(",");
                const filterSwatchId = filterSwatch.dataset.filterId;
                const filterSwatchLabel = filterSwatchId === "filter.p.m.custom.fabric_type" ? filterSwatch.getAttribute('data-value') : filterSwatch.getAttribute('title');

                return currentParamValueArr.includes(filterSwatchLabel) && queryParamName === filterSwatchId;
            });

            if (filterSwatch.closest('.filter-swatch')) {
                if (isActiveSwatch) {
                    filterSwatch.classList.add("active");
                } else {
                    filterSwatch.classList.remove("active");
                }
            } else {
                if (isActiveSwatch) {
                    filterSwatch.classList.add("active");
                    filterSwatch.querySelector('input').checked = true;
                } else {
                    filterSwatch.classList.remove("active");
                    filterSwatch.querySelector('input').checked = false;
                }
            }
        });
    }

    const getCollectionQuery = (loadMore = false) => {
        const filtersDetails = updateFilterQuery(loadMore);


        // Temp boss 2.0 fix
        let filtersString = JSON.stringify(filtersDetails);
        filtersString = filtersString.replaceAll("Boss 2.0", "Boss 2.x");
        filtersString = filtersString.replaceAll("Icon 2.0", "Icon 2.x");

        filtersString = Utils.formatFilterQuery(filtersString);

        filtersString = filtersString.replaceAll("Boss 2.x", "Boss 2.0");
        filtersString = filtersString.replaceAll("Icon 2.x", "Icon 2.0");

        let query;
        if (filtersString !== '""' && filtersString !== "filters:{}}") {
            query = FILTER_PRODUCTS_QUERY.replaceAll(
                "{{filters_details}}",
                filtersString
            );
        } else {
            query = ALL_PRODUCTS_COLLECTION_QUERY;
        }

        // Set SortKey
        const sortByValue = Utils.getQueryParam("sort_by");
        const sortByQueryDictionary = {
            manual: "MANUAL",
            "best-selling": "BEST_SELLING",
            title: "TITLE",
            price: "PRICE",
            oldest: "CREATED",
            newest: "CREATED",
        };
        if (sortByValue) {
            query = query.replaceAll(
                "{{sort_key}}",
                sortByQueryDictionary[sortByValue]
            );

            if (sortByValue === "newest") {
                query = query.replaceAll("{{reverse}}", "true");
            } else {
                query = query.replaceAll("{{reverse}}", "false");
            }
        } else {
            query = query.replaceAll("{{sort_key}}", "COLLECTION_DEFAULT")
                .replaceAll("{{reverse}}", "false");
        }
        return query;
    };

    const getSwatchCollectionQuery = () => {
        const filtersDetails = {
            filters: [],
        };
        const filterQueryParams = Object.entries(Utils.getAllQueryParams());

        if (filterQueryParams.length === 0) {
            return PRODUCT_SWATCHES_QUERY
        }

        filterQueryParams.forEach((filterQueryParam) => {
            const queryParamName = filterQueryParam[0];
            const queryParamValues = filterQueryParam[1].split(",");

            if (queryParamName.includes("filter.v.option.")) {
                const optionName = queryParamName.replaceAll("filter.v.option.", "");
                queryParamValues.forEach((value) => {
                    filtersDetails.filters.push({
                        variantOption: {
                            name: optionName,
                            value: value,
                        },
                    });
                });
            } else if (queryParamName.includes("filter.p.m.")) {
                const metafieldDetails = queryParamName.replaceAll("filter.p.m.", "");
                const metafieldValues = queryParamValues;
                const metafieldDetailsList = metafieldDetails.split(".");
                const metafieldNamespace = metafieldDetailsList[0];
                const metafieldKey = metafieldDetailsList[1];

                metafieldValues.forEach((value) => {
                    filtersDetails.filters.push({
                        productMetafield: {
                            namespace: metafieldNamespace,
                            key: metafieldKey,
                            value: value,
                        },
                    });
                });
            }
        });

        filtersDetails.filters.push({ available: true })
        // Temp boss 2.0 fix
        let filtersString = JSON.stringify(filtersDetails);
        filtersString = filtersString.replaceAll("Boss 2.0", "Boss 2.x");
        filtersString = filtersString.replaceAll("Icon 2.0", "Icon 2.x");

        filtersString = Utils.formatFilterQuery(filtersString);

        filtersString = filtersString.replaceAll("Boss 2.x", "Boss 2.0");
        filtersString = filtersString.replaceAll("Icon 2.x", "Icon 2.0");

        let query;
        if (filtersString !== '""' && filtersString !== "filters:{}}") {
            query = PRODUCT_FILTER_SWATCHES_QUERY.replaceAll(
                "{{filters_details}}",
                filtersString
            );
            // query = PRODUCT_SWATCHES_QUERY;
        } else {
            query = PRODUCT_SWATCHES_QUERY;
        }

        // Set SortKey
        const sortByValue = Utils.getQueryParam("sort_by");
        const sortByQueryDictionary = {
            manual: "MANUAL",
            "best-selling": "BEST_SELLING",
            title: "TITLE",
            price: "PRICE",
            oldest: "CREATED",
            newest: "CREATED",
        };
        if (sortByValue) {
            query = query.replaceAll(
                "{{sort_key}}",
                sortByQueryDictionary[sortByValue]
            );

            if (sortByValue === "newest") {
                query = query.replaceAll("{{reverse}}", "true");
            } else {
                query = query.replaceAll("{{reverse}}", "false");
            }
        } else {
            query = query.replaceAll("{{sort_key}}", "COLLECTION_DEFAULT")
                .replaceAll("{{reverse}}", "false");
        }
        return query;
    };

    renderCollection(getCollectionQuery(), true, true);

    window.addEventListener("paramchange", async () => {
        pageCursor = '';
        applyingFilter = true;
        renderCollection(getCollectionQuery(), false);
    });

    // Sale filter — static UI managed here, tag values pushed into GraphQL via updateFilterQuery
    const SALE_TAG_PARAM = 'filter.p.tag';

    function setSaleTagFilter(tags) {
        const queryParams = new URLSearchParams(window.location.search);
        if (tags.length === 0) {
            queryParams.delete(SALE_TAG_PARAM);
        } else {
            queryParams.set(SALE_TAG_PARAM, tags.join(','));
        }
        history.replaceState(null, null, `${window.location.pathname}?${queryParams.toString()}`);
        Utils.resetFilterBubbles();
        if (!Utils.isMobile()) {
            window.dispatchEvent(paramChangeEvent);
        }
    }

    function syncSaleFilter() {
        const labels = document.querySelectorAll('[data-sale-filter]');
        if (!labels.length) return;
        const current = (Utils.getQueryParam(SALE_TAG_PARAM) || '').split(',').filter(Boolean);
        labels.forEach(label => {
            // Active when ALL of this label's tags are present in current selection
            const active = label.dataset.tags.split(',').every(t => current.includes(t));
            label.classList.toggle('active', active);
            label.querySelector('input').checked = active;
        });
    }

    function initSaleFilter() {
        const saleEl = document.getElementById('sale-filter-static');
        if (!saleEl || saleEl.dataset.saleFilterInit) return;
        saleEl.dataset.saleFilterInit = 'true';

        saleEl.querySelector('.filter-option__toggle').addEventListener('click', () => {
            saleEl.classList.toggle('close');
        });

        // Re-sync checkbox state on any filter change (clear all, URL change, etc.)
        window.addEventListener('paramchange', syncSaleFilter);

        saleEl.querySelectorAll('[data-sale-filter]').forEach(label => {
            // Prevent native checkbox toggle — we control state entirely
            label.querySelector('input').addEventListener('click', (e) => {
                e.preventDefault();
            });

            // All logic on the label so both label-text clicks and input clicks reach it
            label.addEventListener('click', (e) => {
                e.preventDefault(); // prevent synthetic input click from label default

                const clickedTags = label.dataset.tags.split(',');
                const isAllSale = clickedTags.length > 1;
                const current = (Utils.getQueryParam(SALE_TAG_PARAM) || '').split(',').filter(Boolean);

                let newTags;
                if (isAllSale) {
                    // "All Sale": toggle both tags atomically
                    const allPresent = clickedTags.every(t => current.includes(t));
                    newTags = allPresent ? [] : [...clickedTags];
                } else {
                    // Individual: add or remove just this tag
                    const tag = clickedTags[0];
                    newTags = current.includes(tag)
                        ? current.filter(t => t !== tag)
                        : [...current, tag];
                }

                // Instant visual update
                document.querySelectorAll('[data-sale-filter]').forEach(l => {
                    const active = l.dataset.tags.split(',').every(t => newTags.includes(t));
                    l.classList.toggle('active', active);
                    l.querySelector('input').checked = active;
                });

                setSaleTagFilter(newTags);
            });
        });

        syncSaleFilter();
    }

    initSaleFilter();

    // Theme editor JS events
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
            renderCollection(ALL_PRODUCTS_COLLECTION_QUERY);
        });
    }

    function handleScroll() {
        let lastCard = document.querySelector('.collection-bundle:not(.d-none) product-card:last-child');
        if (!lastCard) return;

        const rect = lastCard.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;

        if (inView && !loadingMore && isNextPage) {
            console.log('loading products')
            loadMoreProducts();
            updateProductCardOrderAndMiniBanners('.collection-bundle');
        }
    }

    function loadMoreProducts() {
        loadingMore = true;
        pageNumber = pageNumber + 1;
        renderCollection(getCollectionQuery(true), false, false, true);
    }

    let lastScrollTop = 0;
    let scrollDebounceTimer = null;
    window.addEventListener("scroll", () => {
        handleScroll();
        // Sticky menu
        const isHeaderVisible = Utils.isInViewport(
            document.querySelector(".collection-header"),
            1
        );

        let isBannerVisible = false
        const heroImageContainer = document.querySelector(".collection-hero__image-container");
        if (heroImageContainer !== null) {
            isBannerVisible = Utils.isInViewport(heroImageContainer, 1);
        }
        const stickyMenu = document.querySelector(".collection-sticky-menu");
        const collectionFacetsWrapper = document.querySelector(
            ".collection-facets-wrapper"
        );

        //to handle arrow below filter if overflow
        try {
            let moreFilterArrow = document.querySelector('.collection-product-list .filter_scroll_down');
            if (moreFilterArrow && !Utils.isMobile()) {
                if (isScrollableVertically(collectionFacetsWrapper)) {
                    moreFilterArrow?.classList?.add('d-none');
                } else {
                    moreFilterArrow?.classList?.add('d-none');
                }

                let mainContainer = document.querySelector('.collection-product-list');
                const col1Bottom = collectionFacetsWrapper.getBoundingClientRect().bottom;
                const containerTop = mainContainer.getBoundingClientRect().top;
                const offsetTop = col1Bottom - containerTop + 5;
                moreFilterArrow.style.opacity = '0';
                setTimeout(() => {
                    moreFilterArrow.style.opacity = '1';
                }, 250);
                moreFilterArrow.style.top = `${offsetTop}px`;
                moreFilterArrow.style.bottom = `unset`;
            }

        } catch (e) {
            console.log(e)
        }

        let firstDescriptionVisible = false
        const firstDescription = document.querySelector('.category-separator-description');
        if (firstDescription !== null) {
            firstDescriptionVisible = Utils.isInViewport(firstDescription, 1);
        }
        if (isHeaderVisible || isBannerVisible || firstDescriptionVisible) {
            // collectionsBundlesWrapper.style.marginTop = '0px';
            collectionFacetsWrapper.classList.remove("sticky");

            stickyMenu?.classList.remove('show');
            // stickyMenu.style.display = "none";
            document.querySelector('sticky-header nav')?.classList.add('shadow');
        } else {
            if (!stickyMenu?.classList?.contains('show')) {
                stickyMenu?.classList.add('show');
            }
            // stickyMenu.style.display = "block";
            document.querySelector('sticky-header nav')?.classList.remove('shadow');
            collectionFacetsWrapper.classList.add("sticky");
        }

        if (!document.querySelector('[data-new-collection-structure]')) {
            collectionsElements.forEach((collectionElement) => {
                if (collectionElement.querySelector('[data-collection-product-card]') && collectionElement.querySelector('[data-collection-product-card]') !== null) {
                    const isCollectionVisible = Utils.isInViewport(collectionElement, 1);
                    if (isCollectionVisible && !window.defaultScrollEffect) {
                        const matchedStickyItem = document.querySelector(
                            `.collection-menu__item-sticky[data-handle="${collectionElement.dataset.handle}"]:not(.redirect)`
                        );
                        document
                            .querySelectorAll(".collection-menu__item-sticky")
                            .forEach((stickyItem) => stickyItem.classList.remove("active"));
                        matchedStickyItem?.classList.add("active");
                        var rect = matchedStickyItem?.getBoundingClientRect();
                        var firstElementRect = document.querySelector('.collection-menu__item-sticky').getBoundingClientRect();
                        if (matchedStickyItem && !isFullyVisible(matchedStickyItem)) {
                            document.querySelector('.collection-sticky-menu ul').scrollLeft = rect.left - firstElementRect.left;
                        }
                    }
                }
            });
        }
    }, { passive: true });
})();

function showSkeletonCards(count) {
    const container = document.createElement("div");
    container.classList.add("collection-skeleton");
    container.classList.add("infinite_skeleton");
    // Ensure load-more skeletons sit after existing cards/banners to avoid reordering jitter
    container.style.order = 9999;

    const wrapper = document.createElement("div");
    wrapper.classList.add("subscription-list-skeleton");
    wrapper.classList.add("row");

    const template = document.getElementById("skeleton-card-template");

    for (let i = 0; i < count; i++) {
        const card = template.content.cloneNode(true);
        wrapper.appendChild(card);
    }

    container.appendChild(wrapper);

    // Insert before products load
    document.querySelector(".collection-bundle:not(.d-none)")?.appendChild(container);

    return container; // so you can remove it later after products load
}

function removeSkeleton() {
    let skeleton = document.querySelector('.infinite_skeleton:has(.subscription-list-skeleton)');
    if (skeleton && skeleton.remove) skeleton.remove();
}


function isFullyVisible(element) {
    var rect = element.getBoundingClientRect();
    // Check if all edges of the element are within the viewport
    return rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

function isScrollableVertically(container) {
    return container.scrollHeight > container.clientHeight;
}

function adjustMargin() {
    // const collectionMenuItemEle = document.querySelector('.collection-menu__items');
    // const collectionProductListEle = document.querySelector('.collection-product-list');
    // if (collectionMenuItemEle && collectionProductListEle) {
    //     const collectionMenuItemEleMarginValues = Utility.getMarginValues(collectionProductListEle);
    //     if (collectionMenuItemEleMarginValues?.left > 0) {
    //
    //     }
    //     collectionMenuItemEle.style.marginLeft = (collectionMenuItemEleMarginValues?.left || 0) + 'px';
    // }
}

if (document.querySelector('.plp_new_structure')) {
    adjustMargin();
    window.addEventListener('resize', () => {
        adjustMargin();
    })
}

/* ------------------ Fix Jitter issue ------------------ */
// add class on iOS (incl. iPadOS Safari)
(() => {
    const isIOS = /iP(hone|od|ad)/.test(navigator.platform) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    if (isIOS) document.documentElement.classList.add('is-ios');
})();

// Reorder product cards and mini banners
function updateProductCardOrderAndMiniBanners(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const cards = Array.from(container.querySelectorAll('[data-collection-product-card]'));
    const banners = Array.from(container.querySelectorAll('.collection-mini-banner'));
    if (cards.length === 0 || banners.length === 0) return;

    let allItems = [];
    let bannerIndex = 0;
    let cardIndex = 0;
    let intervals = window.innerWidth < 992 ? [2, 4] : [4, 8];
    let intervalIdx = 0;
    let nextBannerPos = intervals[intervalIdx];
    for (let i = 0; i < cards.length; i++) {
        allItems.push(cards[i]);
        cardIndex++;
        if (cardIndex === nextBannerPos && banners[bannerIndex]) {
            allItems.push(banners[bannerIndex]);
            bannerIndex++;
            intervalIdx = (intervalIdx + 1) % intervals.length;
            nextBannerPos += intervals[intervalIdx];
        }
    }

    allItems.forEach((item, idx) => {
        item.style.order = idx;
    });
}


const el = document.querySelector('.collection-header[data-new-collection-structure]');

function checkSticky() {
    if (!document.querySelector('.topcard-3-variation')) return;

    const rect = el.getBoundingClientRect();

    if (rect.top <= 90) {
        el.classList.add('is-stuck-topcard');
    } else {
        el.classList.remove('is-stuck-topcard');
    }
}

window.addEventListener('scroll', checkSticky);
window.addEventListener('load', checkSticky);